import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonPage,
  IonModal,
  useIonViewDidEnter,
  useIonViewWillLeave,
  IonHeader,
} from "@ionic/react";
import { Holistic } from "@mediapipe/holistic";
import { Camera } from "@mediapipe/camera_utils";
import React, { useCallback, useEffect, useRef, useState } from "react";
import CalibrationErrorModal from "../components/modals/calibration-error-modal";
import CounterError from "../components/modals/counter-error";
import AssessmentCompleteModal from "../components/modals/assessment-complete-modal";
import AssessmentCounter from "../components/modals/assessment-counter";
import LoaderAssesmentModalComponent from "../components/modals/LoaderAssesmentModal";
import PaperPlacementModal from "../components/modals/paper-error-popup";
import AromCountdownTimer from "../components/modals/arom-acountdown";
import ExitConformModal from "../components/modals/PaperPlacementModal";
import FinishIncompleteTestModal from "../components/modals/finish-incomplete-test-modal";
import IncompleteTestModal from "../components/modals/incomplete-test-modal";
import { LocalStorage } from "../services/LocalStorage/LocalStorage.service";
import { useHistory } from "react-router-dom";
import { app, closeApp, getActiveAssessment } from "../movenet";
import SpaceVerificationModal from "../components/modals/SpaceVarificationModal";
import GaitAnalysisCompletedModal from "../components/modals/GaitAnalysisCompletedModal";
import { GaitTest } from "../models/AssessmentRelated/Gait";
import { AromMenuOptions, ASSESSMENT_STATUSES } from "../movenet/params";
import { stopiOSVoiceListening } from "../utils/mobile-bridge";
import { subscribeRemoteButton } from "../services/RemoteInputService";
import { RemoteButton, RemoteButtonEvent } from "../models/RemoteInput";
import { isRemoteControl } from "../utils/assessment-control";
import RaiseArmModal from "../components/modals/RaiseArmModal";
import { StartAssessment, StartTest } from "../services/AssessmentsService";
import {
  AROM_ASSESSMENT,
  FUNCTIONAL_REACH_ASSESSMENT,
  mCTSIB_ASSESSMENT,
  TestType,
} from "../models/Enums";
import { useRecoilState } from "recoil";
import { gaitSentryLogging } from "../vision-algo/gait";
import { sitStandSentryLogging } from "../vision-algo/sitStand";
import { UpperBodyAromSentryLogging } from "../vision-algo/record_AROM_angles";
import AROMRealTime from "../components/modals/arom-real-time";
import {
  currentAssessmentState,
  selectedAssessmentState,
  defaultAssessment,
} from "../data/atoms";
import { Assessment } from "../models/AssessmentRelated/Assessment";
import { getFormattedTimeForTicks } from "../utils/sharedFunction";
import {
  checkiOSCameraPermission,
  getAngleValues,
} from "../utils/mobile-bridge";
import { Test } from "../models/AssessmentRelated/Test";
import { Assessment_Types } from "../vision-algo/assessment_types";
import debugImage from "../assets/images/debug.svg";
import AssesmentErrorModal from "../components/modals/assesment-error-modal";
import ParticipantWithinBoxModal from "../components/modals/participant-within-box-modal";
import AROMInitialModal from "../components/modals/arom-initial-modal";
import AromAssessmentGifModal from "../components/modals/arom-assessment-gif";
import RaiseHandModal from "../components/modals/raise-hand-modal";
import PersonDetectedModal from "../components/modals/person-detected-modal";
import AreYouThereModal from "../components/modals/are-you-there-modal";
import GaitAssessmentCounterModal from "../components/modals/gait-assessment-counter";
// import LoaderModalComponent from "../components/modals/LoaderAssesmentModal";
import CalibratingLoaderModal from "../components/modals/CalibratingLoaderModal";
import RemovePaperModal from "../components/modals/remove-paper-modal";
import WhenReadyRaiseHandModal from "../components/modals/when-ready-raise-hand-modal";
import ExitAssessmentTestModal from "../components/modals/exit-assessment";
import ReturnToStartModal from "../components/modals/return-to-start-modal";
import AROMStartModal from "../components/modals/arom-start-modal";
import AROMTherapistReadyModal from "../components/modals/arom-therapist-ready-modal";
import AROMCompletionModal from "../components/modals/arom-completion";
import AromTopRightGif from "../components/AromTopRightGif";
import AdductionAbductionGif from "../assets/images/AdductionAbductionGif.gif";
import AromAssessmentHandOrientationModal from "../components/modals/arom-assessment-hand-orientation";
import AromMenuModal from "../components/modals/arom-menu-modal";
import GaitCalibrationComplete from "../components/modals/gait-calibration-complete";
import SwayVisualizer from "../components/SwayVisualizer";

import GaitPathwayBlocked from "../components/gait-pathway-blocked";
import Dontwalkmodal from "../components/modals/dont-walk-modal";
import FunctionalReachModals from "../components/modals/functionalReach-modals";
import { functionalReachSentryLogging } from "../vision-algo/functionalReach";
import { tugSentryLogging } from "../vision-algo/tug";
import TugStartModal from "../components/modals/tug-start-modal";
import TugChairBehindPatientModal from "../components/modals/tug-chair-behind-patient";
import NotEnoughSpaceModal from "../components/modals/not-enough-space";
import CTSIBModals from "../components/modals/mCTSIBModals";
import { mCTSIBSentryLogging } from "../vision-algo/mCTSIB";
// TypeScript: declare window.mctsibInstance for global access
declare global {
  interface Window {
    mctsibInstance?: any;
  }
}

const screenText = [""];

// const rep_count_div = document.getElementById("div-sts-rep-count");

// const screenText = [
//   "Place 8.5\"×11\" paper inside the bounding box on the floor",
//   "Walk back until screen turns green",
//   "You have reached the starting distance!",
//   "Raise an arm for 3s to begin the assessment",
//   "Walk",
// ];
var instructionCounter = 1;

const video = document.createElement("video");
let holistic = new Holistic({
  locateFile: (file: any) => {
    return `https://cdn.jsdelivr.net/npm/@mediapipe/holistic@0.4.1633559476/${file}`;
  },
});

const AssessmentPage: React.FC = () => {
  const [angleValue, setAngleValue] = useState(0);
  // Real-time sway data state
  const [swayX, setSwayX] = useState<number[]>([]);
  const [swayY, setSwayY] = useState<number[]>([]);

  // Poll mctsibInstance for sway data every 200ms
  useEffect(() => {
    const interval = setInterval(() => {
      const mctsib = window.mctsibInstance;
      const selectedAssesment = sessionStorage.getItem("selectedAssesment");
      if (!mctsib || selectedAssesment !== "1" || ASSESSMENT_STATUSES.assessment_Completed || ASSESSMENT_STATUSES.assessment_error) {
        setSwayX([]);
        setSwayY([]);
        return;
      }
      // Determine which sway arrays to use based on current sub-assessment
      let swayXArr: any = [];
      let swayYArr: any = [];
      switch (mctsib.current_arom_sub_assessment) {
        case mCTSIB_ASSESSMENT.Open_Eyes:
          swayXArr = mctsib.sway_open_eyes_x || [];
          swayYArr = mctsib.sway_open_eyes_y || [];
          break;
        case mCTSIB_ASSESSMENT.Closed_Eyes:
          swayXArr = mctsib.sway_closed_eyes_x || [];
          swayYArr = mctsib.sway_closed_eyes_y || [];
          break;
        case mCTSIB_ASSESSMENT.Foam_Open_Eyes:
          swayXArr = mctsib.sway_open_eyes_foam_x || [];
          swayYArr = mctsib.sway_open_eyes_foam_y || [];
          break;
        case mCTSIB_ASSESSMENT.Foam_Closed_Eyes:
          swayXArr = mctsib.sway_closed_eyes_foam_x || [];
          swayYArr = mctsib.sway_closed_eyes_foam_y || [];
          break;
        default:
          swayXArr = [];
          swayYArr = [];
      }
      // Always update when arrays change (real-time data is accumulating)
      // For real-time visualization, we need to update whenever arrays grow
      setSwayX((prev) => {
        // Update if length changed (most common case - array growing)
        if (prev.length !== swayXArr.length) {
          return [...swayXArr];
        }
        // Also check last element - handles in-place updates
        if (swayXArr.length > 0 && prev.length > 0) {
          const lastIdx = swayXArr.length - 1;
          if (prev[lastIdx] !== swayXArr[lastIdx]) {
            // console.log(`📊 Updating swayX: last element changed (length: ${swayXArr.length})`);
            return [...swayXArr];
          }
        }
        return prev;
      });
      setSwayY((prev) => {
        // Update if length changed (most common case - array growing)
        if (prev.length !== swayYArr.length) {
          // console.log(
          //   `📊 Updating swayY: ${swayYArr.length} points (was ${prev.length})`
          // );
          return [...swayYArr];
        }
        // Also check last element - handles in-place updates
        if (swayYArr.length > 0 && prev.length > 0) {
          const lastIdx = swayYArr.length - 1;
          if (prev[lastIdx] !== swayYArr[lastIdx]) {
            // console.log(
            //   `📊 Updating swayY: last element changed (length: ${swayYArr.length})`
            // );
            return [...swayYArr];
          }
        }
        return prev;
      });
    }, 200);
    return () => clearInterval(interval);
  }, []);
  const [startCounter, setStartCounter] = useState(false);

  //Workaround to Redo the Assessment
  const handleChildClick = (newMessage: any) => {
    if (angleValue < 87 || angleValue > 93) {
      history.push("/angle-adjustment");
      return;
    }

    // Reset all persistent icon states (but NOT ShowAromTherapistReadyMessage - let assessment restart handle it)
    setRaiseHandPersistent(false);
    setRaiseArmPersistent(false);
    setShowAromTherapistReadyPersistent(false);
    setStartCounter(false);
    setShowAssessmentCounterModal(false);

    setExitModalMessage("default");
    getAngleValues(true);
    //Setting default values for the assessment
    setcurrentAssessmentState(defaultAssessment);
    //Camera settings
    app(
      sessionStorage.getItem("selectedAssesment")! != null
        ? JSON.parse(sessionStorage.getItem("selectedAssesment")!)
        : currentAssessment.assessmentType,
    );
    //To hide the count modal after the assessment is redo
    const temp = document.getElementById("div-sts-rep-count");
    if (temp !== null) {
      temp.classList.add("d-none");
    }
  };

  const [loaderModalText, setLoaderModalText] = useState<String>("");
  const [showPopupModal, setshowPaperModal] = useState(false);
  const [show5xModal, setShow5xModal] = useState(false);
  const [showCalibrationPopupModal, setshowcalibrationModal] = useState(false);
  const [raiseArm, setWhenReadyRaiseHand] = useState(false);
  const [raiseArmPersistent, setRaiseArmPersistent] = useState(false);
  const [CalibrationError, setCalibrationErrorModal] = useState(false);
  const [counterModal, setShowModal1] = useState(false);
  const [assessmentCompleteModal, setShowAssessmentCompleteModal] =
    useState(false);
  const [hdnCalibrationField, setloaderModal] = useState(false);
  const [showMicrophone, setShowMicrophone] = useState(false); // Voice UI element
  const [spaceVerification, setspaceVerification] = useState(false);
  const [gaitAnalysisCompleteModal, setGaitAnalysisCompleted] = useState(false);
  const [exitConformModal, setShowExitConfirmation] = useState(
    (LocalStorage.get("showExitConfirmModal") != undefined &&
      LocalStorage.get("showExitConfirmModal") != null &&
      LocalStorage.get("showExitConfirmModal")) == "true"
      ? true
      : false,
  );
  const [IncompleteTest, setIncompleteTest] = useState(false);
  const [FinishIncompleteTest, setFinishIncompleteTest] = useState(false);
  const [showFinishIncompleteTestModal, setShowFinishIncompleteTestModal] =
    useState(false);
  const [ExitAssessment, setExitAssessment] = useState(false);
  const [notEnoughSpaceAssessment, setNotEnoughSpaceAssessment] =
    useState(false);
  const [assessmentCounter, setShowAssessmentCounterModal] = useState(false);
  const [AssesmentError, setAssesmentError] = useState(false);
  const [ParticipantWithinBox, setParticipantWithinBox] = useState(false);
  const [ShowFaceCameraPhase1Box, setShowFaceCameraPhase1Box] = useState(false);
  const [ShowAromAssessmentGifModal, setShowAromAssessmentGifModal] =
    useState(false);
  const [
    ShowAromAssessmentHandOrientationModal,
    SetShowAromAssessmentHandOrientationModal,
  ] = useState(false);
  const [ShowAromPhase1StartMessage, setShowAromPhase1StartMessage] =
    useState(false);
  const [ShowTugStartMessage, setShowTugStartMessage] = useState(false);
  const [
    ShowTugChairBehindPatientMessage,
    setShowTugChairBehindPatientMessage,
  ] = useState(false);
  const [ShowAromTherapistReadyMessage, setShowAromTherapistReadyMessage] =
    useState(false);
  const [ShowAromCompletionMessage, setShowAromCompletionMessage] =
    useState(false);
  const [RaiseHand, setRaiseHand] = useState(false);
  const [RaiseHandPersistent, setRaiseHandPersistent] = useState(false);
  const [ShowAromTherapistReadyPersistent, setShowAromTherapistReadyPersistent] = useState(false);
  const persistentIconTimeout = useRef<NodeJS.Timeout | null>(null);
  const aromGifTimeout = useRef<NodeJS.Timeout | null>(null);
  const [personDetected, setPersonDetected] = useState(false);
  const [gaitCalibrationComplete, setGaitCalibrationComplete] = useState(false);
  const [gaitDontWalk, setGaitDontWalk] = useState(false);
  const [progress, setProgress] = useState(0);

  // Microphone status listener for voice integration
  useEffect(() => {
    // Microphone status listener
    const handleMicrophoneStatus = (event: any) => {
      const status = event.detail.status;
      console.log("Microphone status in assessment:", status);
      if (status === "ON") {
        setShowMicrophone(true);
      } else {
        setShowMicrophone(false);
      }
    };

    window.addEventListener("microphone-status", handleMicrophoneStatus);

    return () => {
      window.removeEventListener("microphone-status", handleMicrophoneStatus);
    };
  }, []);

  useEffect(() => {
    const button = document.getElementById("hdnGaitDontWalk");

    if (!button) return;

    const handleCustomEvent = (event: CustomEvent<number>) => {
      let receivedValue = event.detail;
      console.log("Received Progress:", receivedValue);

      if (typeof receivedValue !== "number" || isNaN(receivedValue)) {
        receivedValue = 0;
      } else {
        receivedValue = Math.min(Math.max(receivedValue, 0), 100);
      }

      setGaitDontWalk(true);
      setProgress(receivedValue);
    };

    button.addEventListener(
      "dontwalkmodal",
      handleCustomEvent as EventListener,
    );
    return () =>
      button.removeEventListener(
        "dontwalkmodal",
        handleCustomEvent as EventListener,
      );
  }, []);

  useEffect(() => {
    if (FinishIncompleteTest) {
      const timer = setTimeout(() => {
        setShowFinishIncompleteTestModal(true);
      }, 1000);

      return () => clearTimeout(timer); // Cleanup the timer on component unmount
    }
  }, [FinishIncompleteTest]);

  useEffect(() => {
    if (ASSESSMENT_STATUSES.assessment_error) {
      setRaiseHandPersistent(false);
      setRaiseArmPersistent(false);
      setShowAromTherapistReadyPersistent(false);
      setShowAssessmentCounterModal(false); // Hide timer modal to prevent garbage value
      setStartCounter(false); // Hide countdown timer overlay to prevent garbage value
    }
  }, [ASSESSMENT_STATUSES.assessment_error]);

  const [frModalNum, setFrModalNum] = useState(1);
  const [showFrModals, setShowFrModals] = useState(false);

  const [mCTSIBModalNum, setmCTSIBModalNum] = useState(1);
  const [showmCTSIBModals, setShowmCTSIBModals] = useState(false);

  const [gaitPathwayBlocked, setGaitPathwayBlocked] = useState(false);
  const [AreYouThere, setAreYouThere] = useState(false);
  const [GaitAssessmentCounter, setGaitAssessmentCounter] = useState(false);
  const [CalibratingLoader, setCalibratingLoader] = useState(false);
  const [RemovePaper, setRemovePaper] = useState(false);
  const [exitModalMessage, setExitModalMessage] = useState("default");
  const [ReturnToStart, setReturnToStart] = useState(false);
  const [headingUpdated, setHeadingUpdated] = useState(false);

  const [currentAssessment, setcurrentAssessmentState] = useRecoilState(
    currentAssessmentState,
  );

  //5x-test merging
  const [assessmentCompleteModalText, setAssessmentCompleteModalText] =
    useState<String>("");
  const [exitModalText, setExitModalText] = useState<String>("");
  const [selectedAssessmentType, setSelectedAssessmentType] = useRecoilState(
    selectedAssessmentState,
  );

  const [showAromMenuModal, setShowAromMenuModal] = useState(false);

  let history = useHistory();
  let assessment_completion = false;

  let findAssessmentType =
    sessionStorage.getItem("selectedAssesment")! != null
      ? JSON.parse(sessionStorage.getItem("selectedAssesment")!)
      : currentAssessment.assessmentType;
  let location = window.location.href == window.location.origin + "/assessment";

  useIonViewDidEnter(() => {
    getAngleValues(true);
    //Setting default values for the assessment
    setcurrentAssessmentState(defaultAssessment);
    app(
      sessionStorage.getItem("selectedAssesment")! != null
        ? JSON.parse(sessionStorage.getItem("selectedAssesment")!)
        : currentAssessment.assessmentType,
    );
    // //To hide the count modal after the assessment is back from next page
    const temp = document.getElementById("div-sts-rep-count");
    if (temp !== null) {
      temp.classList.add("d-none");
    }
    console.log("ionViewDidEnter event fired");
    debugger;
    console.log("selectedAssessmentType", selectedAssessmentType?.id);
    // CompleteAssessment({});
  });

  useIonViewWillLeave(() => {
    setStartCounter(false);

    // Clear any pending persistent icon timeout on page leave and reset flags
    if (persistentIconTimeout.current) {
      clearTimeout(persistentIconTimeout.current);
      persistentIconTimeout.current = null;
    }
    ASSESSMENT_STATUSES.start_detected = false;
    ASSESSMENT_STATUSES.in_ready_phase = false;
    // Close the hand-raise and phase prompts too: they're modals, and Ionic keeps this page mounted
    // under the next one, so an open prompt would stay on top of it (e.g. the Forward Reach
    // instructions after the remote's NEXT skips every reach and exits)
    setRaiseHand(false);
    setRaiseHandPersistent(false);
    setRaiseArmPersistent(false);
    setShowAromTherapistReadyPersistent(false);
    setParticipantWithinBox(false); // ClosePreviousModals checks state this handler may see stale
    ClosePhasePrompts();

    console.log("ionViewWillLeave event fired");
    // Ensure iOS voice listening is stopped when leaving assessment
    try {
      stopiOSVoiceListening();
    } catch (e) {
      console.warn("Failed to stop iOS voice listening on leave", e);
    }
    if (findAssessmentType == TestType.five_x_sit_stand) {
      sitStandSentryLogging();
    } else if (findAssessmentType == TestType.gait) {
      gaitSentryLogging();
    } else if (findAssessmentType == TestType.upper_body_arom) {
      UpperBodyAromSentryLogging();
    } else if (findAssessmentType == TestType.reach) {
      functionalReachSentryLogging();
    } else if (findAssessmentType == TestType.tug) {
      tugSentryLogging();
    } else if (findAssessmentType == TestType.ctsib) {
      mCTSIBSentryLogging();

      // mCTSIB-specific teardown to prevent stale graph/instance carry-over to next assessment
      setSwayX([]);
      setSwayY([]);
      document.getElementById("output")?.classList.remove("mctsib-cam");
      (window as any).mctsibInstance?.destroy?.();
      (window as any).mctsibInstance = undefined;
    }
    ASSESSMENT_STATUSES.calibration_error_state = false;
    closeApp();
  });

  let Window = window as any;
  Window["AssessmentPageReference"] = {
    component: this,
    SaveAssessment: SaveAssessment,
    CompleteAssessment: CompleteAssessment,
    ReadjustAngelValues: ReadjustAngelValues,
  };

  async function ReadjustAngelValues(yaxis: number, xaxis: number) {
    // console.log("ReadjustAngelValues Function", yaxis, xaxis);
    setAngleValue(yaxis);
    yaxis = Number(yaxis);
    ASSESSMENT_STATUSES.current_angle = yaxis;
    if (ASSESSMENT_STATUSES.assessment_Completed) return;

    if (yaxis < 88 || yaxis > 92) {
      ASSESSMENT_STATUSES.calibration_error_state = true;
      setshowcalibrationModal(false);
      if (camera) await closeApp();

      setCalibrationErrorModal(true);

      // set all modals to false
      setshowcalibrationModal(false);
      setShowAssessmentCounterModal(false);
      setRaiseArmPersistent(false);
      setShowAromTherapistReadyPersistent(false);
      setShowExitConfirmation(false);
      setIncompleteTest(false);
      setExitAssessment(false);
      setAssesmentError(false);
      setFinishIncompleteTest(false);
      setAreYouThere(false);
      setShowAssessmentCompleteModal(false);
      // getAngleValues(false);
      setRaiseHand(false);
      setRaiseHandPersistent(false);
      setGaitCalibrationComplete(false);
      setGaitDontWalk(false);
      setPersonDetected(false);
      setGaitPathwayBlocked(false);
      setReturnToStart(false);
    }
  }

  function CompleteAssessment(gaitAnalysisData: any) {
    console.log("selectedAssessmentType", selectedAssessmentType?.id);
    console.log("Complete Assessment JSON from Shashank", gaitAnalysisData);

    assessment_completion = false;
    checkiOSCameraPermission();
    debugger;
    StartAssessment({
      PatientId: localStorage.getItem("patientServerID"),
      AdmissionDateUTC: new Date(),
      LocalDateTime: new Date(),
      AssessmentTypeId: selectedAssessmentType?.id,
    })
      .then((result: any) => {
        setcurrentAssessmentState((prevState: Assessment) => ({
          ...prevState,
          masterTestId: result.data.masterTestId,
          patientId: Number(localStorage.getItem("patientServerID")),
        }));
        // console.log('current Assessment data : ', currentAssessment);
        let localtime = new Date(
          new Date().setHours(
            new Date().getHours() - new Date().getTimezoneOffset() / 60,
          ),
        ).toISOString();
        let findAssessmentType =
          sessionStorage.getItem("selectedAssesment")! != null &&
          JSON.parse(sessionStorage.getItem("selectedAssesment")!) !=
            currentAssessment.assessmentType
            ? JSON.parse(sessionStorage.getItem("selectedAssesment")!)
            : currentAssessment.assessmentType;
        StartTest({
          LocalDateTime: localtime,
          PatientId: localStorage.getItem("patientServerID"),
          TestLookupId: findAssessmentType ? findAssessmentType : 0,
          MasterTestId: result.data.masterTestId,
          IsSubTest: false,
          AssessmentTypeId:
            localStorage.getItem("selectedAType") &&
            localStorage.getItem("selectedAType") !== undefined
              ? JSON.parse(localStorage.getItem("selectedAType")!)
              : 0,
        })
          .then((result: any) => {
            setcurrentAssessmentState((prevState: Assessment) => ({
              ...prevState,
              visitId: result.data.visitId,
              testId: result.data.testId,
            }));
            if (gaitAnalysisData?.start_time && gaitAnalysisData?.end_time) {
              gaitAnalysisData.start_time = getFormattedTimeForTicks(
                gaitAnalysisData.start_time,
              );
              gaitAnalysisData.end_time = getFormattedTimeForTicks(
                gaitAnalysisData.end_time,
              );
            } else if (gaitAnalysisData?.phases?.length) {
              gaitAnalysisData.start_time = gaitAnalysisData.phases[0].start_time;
              gaitAnalysisData.end_time = gaitAnalysisData.phases[gaitAnalysisData.phases.length - 1].end_time;
            }

            // const jsonstr = JSON.stringify(gaitAnalysisData);
            // const jsonstrwithroot = { root: JSON.parse(jsonstr) };

            const jsonstr = JSON.stringify(gaitAnalysisData);
            const jsonstrwithroot = { root: JSON.parse(jsonstr) };
            setcurrentAssessmentState((prevState: Assessment) => ({
              ...prevState,
              testJson: JSON.stringify(jsonstrwithroot),
            }));
            // setShowAssessmentCompleteModal(true);
            localStorage.setItem(
              "Assesment Summary",
              JSON.stringify(gaitAnalysisData),
            );
            //  const myTimeout = setTimeout(AssessmentCompletedModal, 2000);
            // setTimeout(() => {
            //   // history.push("/select-an-assessment");
            //   history.push("/assessment-notes");
            // }, 3000);

            setShowAssessmentCompleteModal(true);
          })
          .catch((err) => {
            console.error(err);
          });

        // console.log(result);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function SaveAssessment(gaitAnalysisData: any) {
    console.log("selectedAssessmentType", selectedAssessmentType?.id);
    console.log("Complete Assessment JSON from Shashank", gaitAnalysisData);

    assessment_completion = false;
    checkiOSCameraPermission();
    debugger;
    StartAssessment({
      PatientId: localStorage.getItem("patientServerID"),
      AdmissionDateUTC: new Date(),
      LocalDateTime: new Date(),
      AssessmentTypeId: selectedAssessmentType?.id,
    })
      .then((result: any) => {
        setcurrentAssessmentState((prevState: Assessment) => ({
          ...prevState,
          masterTestId: result.data.masterTestId,
          patientId: Number(localStorage.getItem("patientServerID")),
        }));
        // console.log('current Assessment data : ', currentAssessment);
        let localtime = new Date(
          new Date().setHours(
            new Date().getHours() - new Date().getTimezoneOffset() / 60,
          ),
        ).toISOString();
        let findAssessmentType =
          sessionStorage.getItem("selectedAssesment")! != null &&
          JSON.parse(sessionStorage.getItem("selectedAssesment")!) !=
            currentAssessment.assessmentType
            ? JSON.parse(sessionStorage.getItem("selectedAssesment")!)
            : currentAssessment.assessmentType;
        StartTest({
          LocalDateTime: localtime,
          PatientId: localStorage.getItem("patientServerID"),
          TestLookupId: findAssessmentType ? findAssessmentType : 0,
          MasterTestId: result.data.masterTestId,
          IsSubTest: false,
          AssessmentTypeId:
            localStorage.getItem("selectedAType") &&
            localStorage.getItem("selectedAType") !== undefined
              ? JSON.parse(localStorage.getItem("selectedAType")!)
              : 0,
        })
          .then((result: any) => {
            setcurrentAssessmentState((prevState: Assessment) => ({
              ...prevState,
              visitId: result.data.visitId,
              testId: result.data.testId,
            }));
            if (gaitAnalysisData?.start_time && gaitAnalysisData?.end_time) {
              gaitAnalysisData.start_time = getFormattedTimeForTicks(
                gaitAnalysisData.start_time,
              );
              gaitAnalysisData.end_time = getFormattedTimeForTicks(
                gaitAnalysisData.end_time,
              );
            } else if (gaitAnalysisData?.phases?.length) {
              gaitAnalysisData.start_time = gaitAnalysisData.phases[0].start_time;
              gaitAnalysisData.end_time = gaitAnalysisData.phases[gaitAnalysisData.phases.length - 1].end_time;
            }

            const jsonstr = JSON.stringify(gaitAnalysisData);
            const jsonstrwithroot = { root: JSON.parse(jsonstr) };
            setcurrentAssessmentState((prevState: Assessment) => ({
              ...prevState,
              testJson: JSON.stringify(jsonstrwithroot),
            }));
            // setShowAssessmentCompleteModal(true);
            localStorage.setItem(
              "Assesment Summary",
              JSON.stringify(gaitAnalysisData),
            );
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function setInsetDefaultView() {
    var insetoutputCanvas = document.getElementById("insetoutput");
    var insetVal = insetoutputCanvas?.getAttribute("data-val");
    var insetStart = insetoutputCanvas?.getAttribute("data-start");
    insetVal = insetVal == "true" ? "false" : "true";
    insetoutputCanvas?.setAttribute("data-val", insetVal);
    if (insetStart != "false") {
      insetoutputCanvas?.setAttribute("data-start", "false");
    }
  }

  let camera: Camera;
  const videoElement = React.useRef<HTMLVideoElement>(null);

  const AssessmentStartupMsg = () => {
    console.log("currentAssessment", currentAssessment);
    console.log("TestType.gait", TestType.gait);

    // if (findAssessmentType == TestType.gait) {
    //   if (!ASSESSMENT_STATUSES.Use_Depth_Model) {
    //     //   setLoaderModalText(
    //     //     "Walk back around 13 feet to the starting area. The app screen will flash green when you have arrived."
    //     //   );
    //     // } else {
    //     setLoaderModalText(
    //       "Place calibration sheet within the box on the floor."
    //     );
    //   }
    // } else
    if (
      findAssessmentType == TestType.five_x_sit_stand ||
      findAssessmentType == TestType.upper_body_arom ||
      findAssessmentType == TestType.reach ||
      findAssessmentType == TestType.ctsib
    ) {
      setLoaderModalText(
        "Make sure that the participant is standing in the box.",
      );
    }
    if (!CalibrationError) {
      setshowcalibrationModal(true);
    }

    //setShowModal3(true);
    if (findAssessmentType == TestType.gait) {
    } else if (
      findAssessmentType == TestType.five_x_sit_stand ||
      findAssessmentType == TestType.upper_body_arom ||
      findAssessmentType == TestType.reach ||
      findAssessmentType == TestType.tug ||
      findAssessmentType == TestType.ctsib
    ) {
      setTimeout(() => {
        AssessmentStartupMsgContinue();
      }, 3000);
    } else {
      setLoaderModalText(
        "unrecognize Assignment while perform due to assessment type",
      );
      console.log(
        "unrecognize Assignment while perform due to assessment type",
      );
    }
  };

  const AssessmentStartupMsgContinue = () => {
    // setLoaderModalText(
    //   "Make sure that the participant is fully visible in the box while standing."
    // );
    if (!CalibrationError) {
      setshowcalibrationModal(true);
    }
    setTimeout(() => {
      setshowcalibrationModal(false);
      // RaiseArmPopupModal();
    }, 3000);
  };

  const SitDownMsg = () => {
    setLoaderModalText("Now please sit down on a chair, and raise your hand.");
    if (!CalibrationError) {
      setshowcalibrationModal(true);
    }
    setTimeout(() => {
      setshowcalibrationModal(false);
    }, 3000);
  };

  const ShowCalibratingModal = () => {
    /* Closing Paper Placement Modal close if its open
     */
    if (showPopupModal) {
      setshowPaperModal(false);
    }
  };

  const ShowCalibrationCompleteModal = () => {
    try {
      ASSESSMENT_STATUSES.GestureDetectionStart = 1;
      if (findAssessmentType == TestType.gait) {
        ASSESSMENT_STATUSES.Shoulder_time = "";
        ASSESSMENT_STATUSES.Direction = "";
      }

      /* Closing Paper Placement Modal close if its open
       */
      if (showPopupModal) {
        setshowPaperModal(false);
      }
      if (findAssessmentType == TestType.five_x_sit_stand) {
        if (raiseArm) {
          setWhenReadyRaiseHand(false);
        }
      }
      //localStorage.setItem("CalibrationState", "2");
      setLoaderModalText("CalibrateCompleted");
      if (!CalibrationError) {
        setshowcalibrationModal(true);
      }
      setTimeout(() => {
        //closing calibration complete modal
        setshowcalibrationModal(false);
        if (findAssessmentType == TestType.gait) {
          // WalkBackMsg();
          ShowRemovePaperModal();
        }
      }, 1000);
    } catch (e) {
      console.log("ShowCalibrationCompleteModal :" + e);
    }
  };

  const WalkBackMsg = () => {
    if (!showCalibrationPopupModal) {
      if (!CalibrationError) {
        setshowcalibrationModal(true);
      }
    }
    setTimeout(() => {
      // closing walk back instruction
      setshowcalibrationModal(false);
    }, 3000);
  };

  const CountDownCompleteModal = () => {
    //console.log('countdown');
    try {
      if (raiseArm) {
        //Closing RaiseArm Modal if its open before opening Counter Modal
        setWhenReadyRaiseHand(false);
        setRaiseArmPersistent(true);
      }
      if (!assessmentCounter) {
        if (!CalibrationError) {
          // console.log("Temp:", temp);
          // console.log("!showModal if");
          // setShowStepCounter(true);
          setShowAssessmentCounterModal(true);
        }

        var screenText = "WALK";
        //setnewName(screenText);
        setTimeout(() => {
          const temp = document.getElementById("div-sts-rep-count");
          if (temp !== null) {
            temp.classList.remove("d-none");
          }

          if (assessmentCounter) {
            console.log("assessmentCounter if");
            setShowAssessmentCounterModal(false);
            setRaiseArmPersistent(false);
          }
        }, 500);
      }
    } catch (e) {
      console.log("CountDownCompleteModal:" + e);
    }
  };

  const CountDownGaitCompleteModal = () => {
    try {
      setRaiseHand(false);
      setRaiseHandPersistent(false);
      setGaitAssessmentCounter(true);
      setTimeout(() => {
        setGaitAssessmentCounter(false);
      }, 2000);
    } catch (e) {
      console.log("CountDownGaitCompleteModal:" + e);
    }
  };

  const AssessmentCompletedModal = () => {
    if (findAssessmentType == TestType.gait) {
      setGaitAnalysisCompleted(false);
    }
    if (!assessmentCompleteModal) {
      if (findAssessmentType == TestType.gait) {
        setAssessmentCompleteModalText("Gait ");
      } else if (findAssessmentType == TestType.five_x_sit_stand) {
        setAssessmentCompleteModalText("5xSTS ");
      } else if (findAssessmentType == TestType.red_light_green_light) {
        setAssessmentCompleteModalText("RLGL ");
      }
      if (CalibrationError) {
        setShowAssessmentCompleteModal(true);
      }
    }
  };

  const RaiseArmPopupStartModal = () => {
    try {
      setPersonDetected(false);
      setshowcalibrationModal(false);
      setRemovePaper(false);
      setRaiseHand(true);
      setShowmCTSIBModals(false);
    } catch (e) {
      console.log("RaiseArmPopupModal:" + e);
    }
  };
  const RaiseArmPopupStopModal = () => {
    try {
      setshowcalibrationModal(false);
      setRemovePaper(false);
      setRaiseHand(false);
      setShowAromAssessmentGifModal(false);
      if (aromGifTimeout.current) {
        clearTimeout(aromGifTimeout.current);
        aromGifTimeout.current = null;
      }
      setRaiseHandPersistent(true);
    } catch (e) {
      console.log("RaiseArmPopupModal:" + e);
    }
  };

  const ReturnToStartPopupModal = () => {
    try {
      setshowcalibrationModal(false);
      setRemovePaper(false);
      setRaiseHand(false);
      setRaiseHandPersistent(false);
      setReturnToStart(true);

      // For gait/TUG: auto-dismiss after 1.5s
      // For functional reach: stays visible until manually closed by hdnCloseReturnToStartModal
      if (findAssessmentType == TestType.gait || findAssessmentType == TestType.tug) {
        setTimeout(() => {
          setReturnToStart(false);
        }, 1500);
      }
    } catch (e) {
      console.log("ReturnToStartModal:" + e);
    }
  };

  const ShowAssessementErrorPopupModal = () => {
    console.log("Assessment error popup screen");
    try {
      // Clear any pending persistent icon timeout when error modal opens
      if (persistentIconTimeout.current) {
        clearTimeout(persistentIconTimeout.current);
        persistentIconTimeout.current = null;
      }
      // Reset flags when error modal opens
      ASSESSMENT_STATUSES.start_detected = false;
      ASSESSMENT_STATUSES.in_ready_phase = false;

      setFinishIncompleteTest(false);
      setExitAssessment(false);
      setCalibrationErrorModal(false);
      setShowAssessmentCompleteModal(false);
      setRaiseHandPersistent(false);
      setRaiseArmPersistent(false);
      setShowAromTherapistReadyMessage(false);
      setShowAromTherapistReadyPersistent(false);
      setShowAssessmentCounterModal(false);
      setStartCounter(false); // Hide countdown timer overlay
      setParticipantWithinBox(false);
      setRaiseHand(false);
      setGaitCalibrationComplete(false);
      setShowAromAssessmentGifModal(false);
      if (aromGifTimeout.current) {
        clearTimeout(aromGifTimeout.current);
        aromGifTimeout.current = null;
      }
      // Stop all currently playing audio immediately
      if ((window as any).__activeAudioPlayer?.stop) {
        (window as any).__activeAudioPlayer.stop();
      }
      // Remove mCTSIB measurement board overlay and close mCTSIB instruction modals
      document.getElementById("output")?.classList.remove("mctsib-cam");
      setShowmCTSIBModals(false);
      setSwayX([]);
      setSwayY([]);
      setAssesmentError(true);
    } catch (e) {
      console.log("ShowAssessementErrorPopupModal:" + e);
    }
  };

  const ShowParticipantWithinBoxPopupModal = () => {
    console.log("Participant Within the box modal");
    try {
      setParticipantWithinBox(true);

      // Play participant detected audio for mCTSIB and AROM (only when audio instructions are on)
      if (localStorage.getItem("audioInstructionsEnabled") !== "false" &&
          (sessionStorage.getItem("selectedAssesment") === "1" ||
          sessionStorage.getItem("selectedAssesment") === "55")) {
        const participantDetectedAudio = new Audio("audios/mCTSIB/participant_detected.mp3");
        participantDetectedAudio.play();
      }

      setTimeout(() => {
        setParticipantWithinBox(false);
      }, 2000);
    } catch (e) {
      console.log("ShowParticipantWithinBoxPopupModal:" + e);
    }
  };

  const ShowSitStandRaiseHandMessage = () => {
    console.log("Show SitStand Raise Hand Message");
    try {
      if (ParticipantWithinBox) {
        setParticipantWithinBox(false);
      }
      setShowFaceCameraPhase1Box(false);
      setRaiseHand(true);
    } catch (e) {
      console.log("ShowParticipantWithinBoxPopupModal:" + e);
    }
  };

  const ShowAreYouTherePopupModal = () => {
    console.log("Are you there modal");
    try {
      // if(CalibrationError){
      //   setCalibrationErrorModal(false);
      // }
      if (FinishIncompleteTest) {
        setFinishIncompleteTest(false);
      }
      if (IncompleteTest) {
        setIncompleteTest(false);
      }
      setExitAssessment(false);
      setCalibrationErrorModal(false);
      setAssesmentError(false);
      setFinishIncompleteTest(false);
      setRaiseHandPersistent(false);
      setRaiseArmPersistent(false);
      setShowAromTherapistReadyPersistent(false);
      setAreYouThere(true);
    } catch (e) {
      console.log("ShowAreYouTherePopupModal:" + e);
    }
  };

  const ShowCompletionTick = () => {
    console.log("ShowCompletionTick");
    try {
      assessment_completion = true;
    } catch (e) {
      console.log("ShowCompletionTick:" + e);
    }
  };

  const ShowRemovePaperModal = () => {
    console.log("ShowRemovePaperModal");
    try {
      setshowcalibrationModal(false);
      setRemovePaper(true);
    } catch (e) {
      console.log("ShowRemovePaperModal:" + e);
    }
  };

  const StopRemovePaperModal = () => {
    console.log("StopRemovePaperModal");
    try {
      setshowcalibrationModal(false);
      setRemovePaper(false);
    } catch (e) {
      console.log("StopRemovePaperModal:" + e);
    }
  };

  const ShowCalibrationMessageModal = () => {
    console.log("Show Calibration Message Modal");
    try {
      setParticipantWithinBox(false);

      if (RaiseHand) {
        //Closing RaiseHand Modal if its open before Calibration Modal
        setRaiseHand(false);
      }
      setRaiseHandPersistent(false);
      setShowAromTherapistReadyPersistent(false);

      setCalibratingLoader(true);
      setTimeout(() => {
        setCalibratingLoader(false);
      }, 3000);
    } catch (e) {
      console.log("ShowCalibrationMessageModal:" + e);
    }
  };

  const ShowFaceCameraPhase1Modal = () => {
    console.log("Show ShowFaceCameraPhase1 Modal");
    try {
      setShowFaceCameraPhase1Box(true);
      setTimeout(() => {
        setShowFaceCameraPhase1Box(false);
      }, 13000);
    } catch (e) {
      console.log("ShowFaceCameraPhase1Modal:" + e);
    }
  };
  const FaceCameraPalmForwardPhase1close = () => {
    console.log("Show FaceCameraPalmForwardPhase1close Modal");
    try {
      if (sessionStorage.getItem("selectedAssesment") === "1") {
        setShowmCTSIBModals(false);
      } else setShowFaceCameraPhase1Box(false);
    } catch (e) {
      console.log("FaceCameraPalmForwardPhase1close:" + e);
    }
  };

  const AromAssessmentHandOrientationMessage = () => {
    console.log("Show AromAssessmentHandOrientationMessage Modal");
    try {
      SetShowAromAssessmentHandOrientationModal(true);
      setTimeout(() => {
        SetShowAromAssessmentHandOrientationModal(false);
      }, 10000);
    } catch (e) {
      console.log("AromAssessmentHandOrientationMessage:" + e);
    }
  };
  const AromAssessmentGifMessage = () => {
    console.log("Show AromAssessmentGifMessage Modal");
    try {
      SetShowAromAssessmentHandOrientationModal(false);
      setShowAromAssessmentGifModal(true);
      aromGifTimeout.current = setTimeout(() => {
        setShowAromAssessmentGifModal(false);
        aromGifTimeout.current = null;
      }, 10000);
    } catch (e) {
      console.log("AromAssessmentGifMessage:" + e);
    }
  };
  const AromTherapistReadyMessage = () => {
    console.log("Show AromTherapistReadyMessage Modal");
    try {
      setShowAromAssessmentGifModal(false);
      setShowAromTherapistReadyMessage(true);
      setTimeout(() => {
        setShowAromTherapistReadyMessage(false);
      }, 6000);
    } catch (e) {
      console.log("AromTherapistReadyMessage:" + e);
    }
  };
  const AromPhase1StartMessage = () => {
    console.log("Show AromPhase1StartMessage Modal");
    try {
      setShowAromTherapistReadyMessage(false);
      setShowAromAssessmentGifModal(false);
      setShowAromPhase1StartMessage(true);
      setTimeout(() => {
        setShowAromPhase1StartMessage(false);
      }, 3000);
    } catch (e) {
      console.log("AromPhase1StartMessage:" + e);
    }
  };
  const TugStartMessage = () => {
    console.log("Show TugStartMessage Modal");
    try {
      // setShowAromTherapistReadyMessage(false);
      // setShowAromAssessmentGifModal(false);
      setShowTugStartMessage(true);
      setTimeout(() => {
        setShowTugStartMessage(false);
      }, 6000);
    } catch (e) {
      console.log("TugStartMessage:" + e);
    }
  };
  const TugChairBhindPatientMessage = () => {
    console.log("Show TugStartMessage Modal");
    try {
      // setShowAromTherapistReadyMessage(false);
      // setShowAromAssessmentGifModal(false);
      setShowTugChairBehindPatientMessage(true);
      setTimeout(() => {
        setShowTugChairBehindPatientMessage(false);
      }, 6000);
    } catch (e) {
      console.log("TugStartMessage:" + e);
    }
  };

  const AromPhase1StartMessageClose = () => {
    console.log("AromPhase1StartMessageClose");
    try {
      setShowAromPhase1StartMessage(false);
    } catch (e) {
      console.log("AromPhase1StartMessage:" + e);
    }
  };
  const AromCompletionMessage = () => {
    console.log("Show AromCompletionMessage Modal");
    try {
      setShowAromCompletionMessage(true);
      setTimeout(() => {
        setShowAromCompletionMessage(false);
        // this is added just for Phase 1 demo purposes
        // handleChildClick("return to angle adjustment");
      }, 2500);
    } catch (e) {
      console.log("AromCompletionMessage:" + e);
    }
  };
  // Closes the current phase's prompts when the remote's NEXT skips a phase or REWIND goes back one;
  // the phase that runs next opens its own
  const ClosePhasePrompts = () => {
    ClosePreviousModals();
    setShowAromCompletionMessage(false);
    setRaiseHand(false);
    setReturnToStart(false);
    setShowFrModals(false);
    setShowmCTSIBModals(false);
    setShowFaceCameraPhase1Box(false);
    SetShowAromAssessmentHandOrientationModal(false);
    setShowAromAssessmentGifModal(false);
    if (aromGifTimeout.current) {
      clearTimeout(aromGifTimeout.current);
      aromGifTimeout.current = null;
    }
    setShowAromTherapistReadyMessage(false);
  };

  const ClosePreviousModals = () => {
    console.log("Closing Previous Modals");
    try {
      if (ParticipantWithinBox) {
        setParticipantWithinBox(false);
      }
      if (RaiseHand) {
        setRaiseHand(false);
      }
      // Clear persistent icon and any pending timeout (safety net for sit-stand, etc.)
      if (persistentIconTimeout.current) {
        clearTimeout(persistentIconTimeout.current);
        persistentIconTimeout.current = null;
      }
      setRaiseHandPersistent(false);
      setShowAromTherapistReadyPersistent(false);
      // if (CalibratingLoader) {
      //   setCalibratingLoader(false);
      // }
    } catch (e) {
      console.log("Closing Previous Modals:" + e);
    }
  };

  const ShowAssessmentCompletionModal = () => {
    console.log("Show Assessment Completion Modal");
    try {
      // Clear any pending persistent icon timeout when completion modal opens
      if (persistentIconTimeout.current) {
        clearTimeout(persistentIconTimeout.current);
        persistentIconTimeout.current = null;
      }
      // Reset flags when completion modal opens
      ASSESSMENT_STATUSES.start_detected = false;
      ASSESSMENT_STATUSES.in_ready_phase = false;

      // Hide all persistent icons and modals
      setRaiseHandPersistent(false);
      setRaiseArmPersistent(false);
      setShowAromTherapistReadyMessage(false);
      setShowAromTherapistReadyPersistent(false);
      setShowAssessmentCounterModal(false);
      setStartCounter(false); // Hide countdown timer overlay

      setShowAssessmentCompleteModal(true);
    } catch (e) {
      console.log("ShowAssessmentCompletionModal:" + e);
    }
  };

  const handleExitClick = (val: string) => {
    setExitModalMessage(val);
  };

  const openModal = () => {
    // Stop voice listening when exit is initiated
    console.log("🔊 Stopping voice listening due to exit button click");
    stopiOSVoiceListening();

    if (
      exitModalMessage === "default" ||
      ASSESSMENT_STATUSES.sitstand_assessment_started
    ) {
      // Show this before calibration is complete
      ASSESSMENT_STATUSES.exit_assessment_modal = true;
      setExitAssessment(true);
    } else {
      // Show this after calibration is complete
      showFinishIncompleteTest();
    }
  };

  // Leaves without a modal or saving (remote NEXT before anything was measured), like the exit modal's Exit
  const exitToAssessmentSelection = () => {
    stopiOSVoiceListening();
    ASSESSMENT_STATUSES.incomplete_test = true;
    ASSESSMENT_STATUSES.exit_assessment_modal = true;
    if ((window as any).__activeAudioPlayer?.stop) {
      (window as any).__activeAudioPlayer.stop();
    }
    document.getElementById("output")?.classList.remove("mctsib-cam");
    const counter = sessionStorage.getItem("retry-counter");
    if (counter)
      sessionStorage.setItem("retry-counter", (Number(counter) + 1).toString());
    history.push("/select-an-assessment");
  };

  // Back to the beginning from the "Incomplete Test" choice (remote REWIND after a stop), like the
  // complete modal's Discard & Redo
  const restartStoppedAssessment = () => {
    // Both flags, like the modal's own Exit & Discard: FinishIncompleteTest opens the modal shown by
    // showFinishIncompleteTestModal a second later
    setFinishIncompleteTest(false);
    setShowFinishIncompleteTestModal(false);
    // The stop froze the assessment with this flag; the new instance would otherwise stay frozen
    ASSESSMENT_STATUSES.exit_assessment_modal = false;
    ASSESSMENT_STATUSES.save_incomplete_test = false;
    handleChildClick("Redo");
  };

  // After REWIND restarted a stopped phase (multi-phase): close the "Incomplete Test" choice and the
  // stopped phase's countdown and start message
  const closeIncompleteTestForPhaseRestart = () => {
    setFinishIncompleteTest(false);
    setShowFinishIncompleteTestModal(false);
    ASSESSMENT_STATUSES.save_incomplete_test = false;
    setStartCounter(false);
    setShowAssessmentCounterModal(false);
    document.getElementById("hdnAromPhase1StartMessageClose")?.click();
  };

  // Closes the Assessment Error modal, or the complete modal's error variant, before a remote REWIND
  // restarts (like the error modal's Retry)
  const closeAssessmentError = () => {
    document.getElementById("hdnRemoveGaitDontWalk")?.click();
    setAssesmentError(false);
    setShowAssessmentCompleteModal(false);
    setStartCounter(false);
    setShowAssessmentCounterModal(false);
    document.getElementById("hdnAromPhase1StartMessageClose")?.click();
  };

  // Back to the beginning from an assessment error (remote REWIND), like Discard & Redo
  const restartAfterAssessmentError = () => {
    closeAssessmentError();
    // Not every assessment's constructor clears it; left set, the next completion would show the error variant
    ASSESSMENT_STATUSES.assessment_error = false;
    handleChildClick("Redo");
  };

  // "Exit & save / Exit & discard" choice
  const showFinishIncompleteTest = () => {
    ASSESSMENT_STATUSES.save_incomplete_test = true;
    setAreYouThere(false);
    setCalibrationErrorModal(false);
    setAssesmentError(false);
    setShowAssessmentCompleteModal(false);
    setFinishIncompleteTest(true);
  };

  // BLE remote START_STOP: a third way to start, alongside hand raise and voice, under the same
  // pre-conditions; while the test is running it stops it and shows the exit choice. NEXT, while
  // nothing is running, moves to the next phase / results or leaves. REWIND goes back one phase
  // after a phase completes (multi-phase). On a completed test, NEXT = View Results; REWIND redoes
  // the last phase (multi-phase) or = Discard & Redo (single phase). On a stopped test ("Incomplete
  // Test"), NEXT = Exit & Discard; REWIND restarts the assessment (single phase) or the stopped phase
  // (multi-phase). UP/DOWN select the patient before the start. Each assessment class decides in
  // receiveStartTrigger/receiveStopTrigger/receiveNextTrigger/receiveRewindTrigger/cyclePatient whether
  // a press applies. Kept in a ref so the subscription always sees the current state.
  const handleRemoteButton = useRef<(event: RemoteButtonEvent) => void>(() => {});
  handleRemoteButton.current = (event) => {
    // Hand-gestures control mode (Assessment Selection screen): the remote is ignored
    if (!isRemoteControl()) return;
    const assessment: any = getActiveAssessment();
    const singlePhase = [
      TestType.gait,
      TestType.tug,
      TestType.five_x_sit_stand,
    ].includes(Number(findAssessmentType));
    // Presses a modal's own button, so the remote behaves exactly like a tap (no extra modals)
    const pressModalButton = (id: string) => {
      const button: any = document.getElementById(id);
      if (button && !button.disabled) button.click();
    };

    // Assessment Error: the error modal (Exit & Discard / Retry), or the complete modal's error variant
    // (FR losing the patient mid-reach). Treated like a stop: NEXT = exit and discard. REWIND restarts
    // the phase that errored (multi-phase), or the whole assessment (single phase, or an error during
    // setup). START_STOP does nothing here.
    const errorVariantShown =
      assessmentCompleteModal && ASSESSMENT_STATUSES.assessment_error;
    if (AssesmentError || errorVariantShown) {
      if (event.button === RemoteButton.NEXT) {
        pressModalButton(
          AssesmentError
            ? "btnAssessmentErrorExitDiscard"
            : "btnAssessmentErrorDiscard",
        );
      } else if (event.button === RemoteButton.REWIND) {
        if (!singlePhase && assessment?.rewindErroredPhase?.("remote")) {
          closeAssessmentError();
        } else {
          restartAfterAssessmentError();
        }
      }
      return;
    }

    // "Incomplete Test" choice (after a stop or the header Exit). NEXT = Exit & Discard. REWIND goes
    // back to the beginning (single phase) or restarts the stopped phase (multi-phase, only after a
    // stop). START_STOP does nothing here.
    if (FinishIncompleteTest) {
      if (event.button === RemoteButton.NEXT) {
        pressModalButton("btnIncompleteTestExitDiscard");
      } else if (event.button === RemoteButton.REWIND) {
        if (singlePhase) {
          restartStoppedAssessment();
        } else if (assessment?.rewindStoppedPhase?.("remote")) {
          closeIncompleteTestForPhaseRestart();
        }
      }
      return;
    }

    // Completed test (no modals in between): NEXT goes to the results (View Results). REWIND goes
    // back one phase in multi-phase assessments (redo the last phase), and to the beginning in
    // single-phase ones (Discard & Redo). The error variant is handled above.
    if (assessmentCompleteModal) {
      if (event.button === RemoteButton.NEXT) {
        pressModalButton("btnAssessmentCompleteViewResults");
      } else if (event.button === RemoteButton.REWIND) {
        if (singlePhase) {
          pressModalButton("btnAssessmentCompleteRedo");
        } else if (assessment?.receiveRewindTrigger?.("remote", true)) {
          setShowAssessmentCompleteModal(false);
        }
      }
      return;
    }

    // UP/DOWN: cycle the patient to the next person right/left on screen (until the start)
    if (event.button === RemoteButton.UP || event.button === RemoteButton.DOWN) {
      assessment?.cyclePatient?.(event.button === RemoteButton.UP ? 1 : -1, "remote");
      return;
    }

    // NEXT while nothing is running: next phase, results, or leave (single phase / nothing measured)
    if (event.button === RemoteButton.NEXT) {
      if (assessment?.receiveNextTrigger?.("remote") === "exit") {
        exitToAssessmentSelection();
      }
      return;
    }

    // REWIND between phases: redo the phase that just completed (multi-phase assessments only)
    if (event.button === RemoteButton.REWIND) {
      assessment?.receiveRewindTrigger?.("remote");
      return;
    }

    if (event.button !== RemoteButton.START_STOP) return;
    if (assessment?.receiveStartTrigger?.("remote")) return;
    if (assessment?.receiveStopTrigger?.("remote")) {
      stopiOSVoiceListening();
      showFinishIncompleteTest();
    }
  };
  useEffect(
    () => subscribeRemoteButton((event) => handleRemoteButton.current(event)),
    [],
  );

  let assessment_result_class = "assessment-complete-modal";
  if (ASSESSMENT_STATUSES.assessment_error) {
    assessment_result_class = "assesment-error-modal-wrap";
  }

  return (
    <>
      <button
        title="hiddenPaperError"
        className="d-none"
        id="hdnPaperError"
      ></button>
      <button
        title="hdnPaperPlacementPopup"
        className="d-none"
        id="hdnPaperPlacementPopup"
        onClick={() => {
          AssessmentStartupMsg();
        }}
      ></button>
      <button
        title="hdnPaperPlacementStopPopup"
        className="d-none"
        id="hdnPaperPlacementStopPopup"
        onClick={() => {
          setshowcalibrationModal(false);
        }}
      ></button>
      <button
        title="hdnCalibrationCompleteStopPopup"
        className="d-none"
        id="hdnCalibrationCompleteStopPopup"
        onClick={() => {
          StopRemovePaperModal();
        }}
      ></button>
      <button
        title="hdnCalibrationPopup"
        className="d-none"
        id="hdnCalibrationPopup"
        onClick={() => {
          ShowCalibratingModal();
        }}
      ></button>
      <button
        title="hdnReturnToStartModalPopup"
        className="d-none"
        id="hdnReturnToStartModalPopup"
        onClick={() => {
          ReturnToStartPopupModal();
        }}
      ></button>
      <button
        title="hdnRaiseArmModalPopup"
        className="d-none"
        id="hdnRaiseArmModalPopup"
        onClick={() => {
          RaiseArmPopupStartModal();
        }}
      ></button>
      <button
        title="hdnPersonDetectedModalPopup"
        className="d-none"
        id="hdnPersonDetectedModalPopup"
        onClick={() => {
          setShowTugChairBehindPatientMessage(false);
          setPersonDetected(true);
          setTimeout(() => {
            setPersonDetected(false);
          }, 1500);
        }}
      ></button>
      <button
        title="hdnGaitCalibrationComplete"
        className="d-none"
        id="hdnGaitCalibrationComplete"
        onClick={() => {
          // Clear any pending persistent icon timeout (sit-stand, gait, etc.)
          if (persistentIconTimeout.current) {
            clearTimeout(persistentIconTimeout.current);
            persistentIconTimeout.current = null;
          }
          setGaitDontWalk(false);
          setParticipantWithinBox(false);
          setRaiseHand(false);
          setRaiseHandPersistent(false);
          setShowAromTherapistReadyPersistent(false);
          setGaitCalibrationComplete(true);
          setTimeout(() => {
            setGaitCalibrationComplete(false);
          }, 1500);
        }}
      ></button>
      <button
        title="hdnRemoveGaitDontWalk"
        className="d-none"
        id="hdnRemoveGaitDontWalk"
        onClick={() => {
          setGaitDontWalk(false);
        }}
      ></button>
      <button
        title="hdnGaitDontWalk"
        className="d-none"
        id="hdnGaitDontWalk"
        onClick={() => {
          setGaitDontWalk(true);
        }}
      ></button>
      <button
        title="hdnGaitPathwayBlocked"
        className="d-none"
        id="hdnGaitPathwayBlocked"
        onClick={() => {
          setGaitPathwayBlocked(true);
          setTimeout(() => {
            setGaitPathwayBlocked(false);
          }, 1500);
        }}
      ></button>
      <button
        title="hdnRaiseArmStopModalPopup"
        className="d-none"
        id="hdnRaiseArmStopModalPopup"
        onClick={() => RaiseArmPopupStopModal()}
      ></button>
      <button
        title="hdnAssessementErrorPopup"
        className="d-none"
        id="hdnAssessementErrorPopup"
        onClick={() => {
          ShowAssessementErrorPopupModal();
        }}
      ></button>
      <button
        title="hdnParticiantWithinBox"
        className="d-none"
        id="hdnParticiantWithinBox"
        onClick={() => {
          ShowParticipantWithinBoxPopupModal();
        }}
      ></button>
      <button
        title="hdnSitStandRaiseHandMessage"
        className="d-none"
        id="hdnSitStandRaiseHandMessage"
        onClick={() => {
          ShowSitStandRaiseHandMessage();
        }}
      ></button>
      <button
        title="hdnAreYouTherePopup"
        className="d-none"
        id="hdnAreYouTherePopup"
        onClick={() => {
          ShowAreYouTherePopupModal();
        }}
      ></button>
      <button
        title="hdnCalibrationMessage"
        className="d-none"
        id="hdnCalibrationMessage"
        onClick={() => {
          ShowCalibrationMessageModal();
        }}
      ></button>
      <button
        title="hdnFaceCameraPalmForwardPhase1"
        className="d-none"
        id="hdnFaceCameraPalmForwardPhase1"
        onClick={() => {
          if (sessionStorage.getItem("selectedAssesment") === "1") {
            setmCTSIBModalNum(1);
            setShowmCTSIBModals(true);
            setHeadingUpdated(true);
          }
          if (sessionStorage.getItem("selectedAssesment") === "56" ||
            sessionStorage.getItem("selectedAssesment") === "2") {
            setShowAromTherapistReadyPersistent(false);
            setRaiseHandPersistent(false);
            setFrModalNum(1);
            setShowFrModals(true);
          }
          if (sessionStorage.getItem("selectedAssesment") === "55") {
            ShowFaceCameraPhase1Modal();
            setHeadingUpdated(true);
          }
        }}
      ></button>
      <button
        title="hdnFaceCameraPalmForwardPhase1close"
        className="d-none"
        id="hdnFaceCameraPalmForwardPhase1close"
        onClick={() => {
          FaceCameraPalmForwardPhase1close();
        }}
      ></button>
      <button
        title="hdnAromAssessmentGifMessage"
        className="d-none"
        id="hdnAromAssessmentGifMessage"
        onClick={() => {
          if (sessionStorage.getItem("selectedAssesment") === "2") {
            setFrModalNum(3);
            setShowFrModals(true);
          } else AromAssessmentGifMessage();
        }}
      ></button>
      <button
        title="hdnAromAssessmentHandOrientationMessage"
        className="d-none"
        id="hdnAromAssessmentHandOrientationMessage"
        onClick={() => {
          if (sessionStorage.getItem("selectedAssesment") === "2") {
            setFrModalNum(2);
            setShowFrModals(true);
          } else AromAssessmentHandOrientationMessage();
        }}
      ></button>
      <button
        title="hdnAromPhase1StartMessage"
        className="d-none"
        id="hdnAromPhase1StartMessage"
        onClick={() => {
          AromPhase1StartMessage();
        }}
      ></button>
      <button
        title="hdnTugStartMessage"
        className="d-none"
        id="hdnTugStartMessage"
        onClick={() => {
          TugStartMessage();
        }}
      ></button>
      <button
        title="hdnTugChairBehindPatientMessage"
        className="d-none"
        id="hdnTugChairBehindPatientMessage"
        onClick={() => {
          TugChairBhindPatientMessage();
        }}
      ></button>
      <button
        title="hdnNotEnoughSpaceModalPopup"
        className="d-none"
        id="hdnNotEnoughSpaceModalPopup"
        onClick={() => {
          // TugChairBhindPatientMessage();
          setNotEnoughSpaceAssessment(true);
          // setTimeout(() => {
          //   setNotEnoughSpaceAssessment(false);
          // }, 3000);
        }}
      ></button>
      <button
        title="hdnAromTherapistReadyMessage"
        className="d-none"
        id="hdnAromTherapistReadyMessage"
        onClick={() => {
          if (sessionStorage.getItem("selectedAssesment") === "2" ||
              sessionStorage.getItem("selectedAssesment") === "55" ||
              sessionStorage.getItem("selectedAssesment") === "1") {
            setShowFrModals(false);
            setShowmCTSIBModals(false);
            setShowAromAssessmentGifModal(false);
            if (aromGifTimeout.current) {
              clearTimeout(aromGifTimeout.current);
              aromGifTimeout.current = null;
            }

            // AROM/mCTSIB: first sub-assessment shows full raise-hand modal,
            // subsequent sub-assessments show persistent icon directly
            if ((sessionStorage.getItem("selectedAssesment") === "55" &&
                sessionStorage.getItem("aromAssessmentIndex") !== "shoulderA&A") ||
                (sessionStorage.getItem("selectedAssesment") === "1" &&
                sessionStorage.getItem("mCTSIBAssessmentIndex") !== "openEyes")) {
              setRaiseHand(false);
              setRaiseHandPersistent(true);
            } else {
              setRaiseHandPersistent(false);
              setRaiseHand(true);
            }

            // Reset flags for new phase
            ASSESSMENT_STATUSES.in_ready_phase = true;
            ASSESSMENT_STATUSES.start_detected = false;

          } else AromTherapistReadyMessage();
          //  else if (sessionStorage.getItem("selectedAssesment") === "1") {
          //   setShowmCTSIBModals(false);
          //   setShowAromTherapistReadyMessage(true);
          //   setTimeout(() => {
          //     setShowAromTherapistReadyMessage(false);
          //   }, 6000);
          // }
        }}
      ></button>
      <button
        title="hdnAromPhase1StartMessageClose"
        className="d-none"
        id="hdnAromPhase1StartMessageClose"
        onClick={() => {
          if (sessionStorage.getItem("selectedAssesment") === "2")
            setShowFrModals(false);
          if (sessionStorage.getItem("selectedAssesment") === "1")
            setShowmCTSIBModals(false);
          else AromPhase1StartMessageClose();
        }}
      ></button>

      <button
        title="hdnAromCompletionMessage"
        className="d-none"
        id="hdnAromCompletionMessage"
        onClick={() => {
          AromCompletionMessage();
        }}
      ></button>
      <button
        title="hdnHideHandRaisePersistentIcon"
        className="d-none"
        id="hdnHideHandRaisePersistentIcon"
        onClick={() => {
          // Clear any pending timeout that would show the persistent icon
          if (persistentIconTimeout.current) {
            clearTimeout(persistentIconTimeout.current);
            persistentIconTimeout.current = null;
          }

          // Set flags synchronously to prevent timeout from showing icon
          ASSESSMENT_STATUSES.start_detected = true;
          ASSESSMENT_STATUSES.in_ready_phase = false;

          setShowAromTherapistReadyMessage(false);
          setShowAromTherapistReadyPersistent(false);
          setRaiseHand(false);
          setRaiseHandPersistent(false);
        }}
      ></button>
      <button
        title="hdnShowHandRaisePersistentIcon"
        className="d-none"
        id="hdnShowHandRaisePersistentIcon"
        onClick={() => {
          if (sessionStorage.getItem("selectedAssesment") === "2") {
            setRaiseHandPersistent(true);
          } else {
            setShowAromTherapistReadyPersistent(true);
          }
        }}
      ></button>
      <button
        title="hdnCloseReturnToStartModal"
        className="d-none"
        id="hdnCloseReturnToStartModal"
        onClick={() => {
          setReturnToStart(false);
        }}
      ></button>
      <button
        title="hdnRetryCurrentPhase"
        className="d-none"
        id="hdnRetryCurrentPhase"
        onClick={() => {
          // Get reference to assessment instance and retry current phase
          if ((window as any).functionalReach) {
            (window as any).functionalReach.retryCurrentPhase();
          }
          if ((window as any).mctsibInstance) {
            (window as any).mctsibInstance.retryCurrentPhase();
          }
          if ((window as any).sitStandInstance) {
            (window as any).sitStandInstance.retryAssessment();
          }
          if ((window as any).aromInstance) {
            (window as any).aromInstance.retryCurrentPhase();
          }
        }}
      ></button>
      <button
        title="hdnClosePhasePrompts"
        className="d-none"
        id="hdnClosePhasePrompts"
        onClick={() => {
          ClosePhasePrompts();
        }}
      ></button>
      <button
        title="hdnClosePreviousModals"
        className="d-none"
        id="hdnClosePreviousModals"
        onClick={() => {
          ClosePreviousModals();
        }}
      ></button>
      <button
        title="hdnAssessmentCompletionModal"
        className="d-none"
        id="hdnAssessmentCompletionModal"
        onClick={() => {
          ShowAssessmentCompletionModal();
        }}
      ></button>
      <button
        className="d-none"
        id="hdnAssessmentStartUpMessage"
        onClick={() => {
          AssessmentStartupMsg();
        }}
      ></button>
      <button
        className="d-none"
        id="hdnSitDownMessage"
        onClick={() => {
          SitDownMsg();
        }}
      ></button>
      <button
        className="d-none"
        id="hdnAssessmentCompletePopup"
        onClick={() => {
          AssessmentCompletedModal();
        }}
      ></button>
      <button
        title="hdnCalibrationCompletePopup"
        className="d-none"
        id="hdnCalibrationCompletePopup"
        onClick={() => {
          ShowCalibrationCompleteModal();
        }}
      ></button>
      <button
        title="hdnWalkBackPopup"
        className="d-none"
        id="hdnWalkBackPopup"
        onClick={() => {
          WalkBackMsg();
        }}
      ></button>
      <button
        title="hdnCountDownCompletePopup"
        className="d-none"
        id="hdnCountDownCompletePopup"
        onClick={() => {
          CountDownCompleteModal();
        }}
      ></button>
      <button
        title="hdnCountDownGaitCompletePopup"
        className="d-none"
        id="hdnCountDownGaitCompletePopup"
        onClick={() => {
          CountDownGaitCompleteModal();
        }}
      ></button>
      <button
        title="hdnCompletionTickPopup"
        className="d-none"
        id="hdnCompletionTickPopup"
        onClick={() => {
          ShowCompletionTick();
        }}
      ></button>
      <button
        title="hdnRemovePaperPopup"
        className="d-none"
        id="hdnRemovePaperPopup"
        onClick={() => {
          ShowRemovePaperModal();
        }}
      ></button>
      <button
        className="d-none"
        id="btn-arom-assessment-counter"
        onClick={() => {
          console.warn("cliked startCounter: ", startCounter);
          setStartCounter(!startCounter);
        }}
      ></button>
      <IonModal
        className="calibration-error-modal-wrap"
        backdropDismiss={false}
        isOpen={CalibrationError}
        placeholder={undefined}
      >
        <CalibrationErrorModal
          setCalibrationError={setCalibrationErrorModal}
          angleValue={angleValue}
        ></CalibrationErrorModal>
      </IonModal>
      <IonModal
        className="remove-paper-modal-wrap"
        backdropDismiss={false}
        isOpen={RemovePaper}
        placeholder={undefined}
      >
        <RemovePaperModal setRemovePaper={setRemovePaper}></RemovePaperModal>
      </IonModal>
      <IonModal
        className="counter-error-modal"
        backdropDismiss={false}
        isOpen={counterModal}
        placeholder={undefined}
      >
        <CounterError></CounterError>
      </IonModal>
      <IonModal
        className="counter-error-modal"
        backdropDismiss={false}
        isOpen={assessmentCounter}
        placeholder={undefined}
      >
        <AssessmentCounter
          setShowModal3={setShowAssessmentCounterModal}
        ></AssessmentCounter>
      </IonModal>
      <IonModal
        className="person-detected-modal-wrap"
        // className="return-to-start-modal-wrap"
        backdropDismiss={false}
        isOpen={ReturnToStart}
        placeholder={undefined}
      >
        <ReturnToStartModal
          setReturnToStart={setReturnToStart}
        ></ReturnToStartModal>
      </IonModal>
      <IonModal
        // className={assessment_result_class}
        className="person-detected-modal-wrap"
        backdropDismiss={false}
        isOpen={assessmentCompleteModal}
        placeholder={undefined}
      >
        <AssessmentCompleteModal
          setShowModal2={setShowAssessmentCompleteModal}
          assessmentCompleteModalText={assessmentCompleteModalText}
          onChildClick={handleChildClick}
        ></AssessmentCompleteModal>
      </IonModal>
      {/* {!ASSESSMENT_STATUSES.Use_Depth_Model && ( */}
      <IonModal
        className="loader-popup-modal"
        backdropDismiss={false}
        isOpen={showCalibrationPopupModal}
        placeholder={undefined}
      >
        <LoaderAssesmentModalComponent
          loaderModalText={loaderModalText}
          setloaderModal={setshowcalibrationModal}
        ></LoaderAssesmentModalComponent>
      </IonModal>
      {/* )} */}
      <IonModal
        className="paper-placement-modal"
        backdropDismiss={false}
        isOpen={exitConformModal}
        placeholder={undefined}
      >
        <ExitConformModal
          setPaperPlacement={setShowExitConfirmation}
          exitModalText={exitModalText}
        ></ExitConformModal>
      </IonModal>
      <IonModal
        className="finish-incomplete-test-modal-wrap"
        backdropDismiss={false}
        isOpen={showFinishIncompleteTestModal}
        placeholder={undefined}
      >
        <FinishIncompleteTestModal
          setFinishIncompleteTest={setFinishIncompleteTest}
          setShowFinishIncompleteTestModal={setShowFinishIncompleteTestModal}
          onChildClick={handleChildClick}
        ></FinishIncompleteTestModal>
      </IonModal>
      <IonModal
        className="finish-incomplete-test-modal-wrap"
        backdropDismiss={false}
        isOpen={showAromMenuModal}
        placeholder={undefined}
      >
        <AromMenuModal
          setShowAromMenuModal={setShowAromMenuModal}
          // In future when we add functionality to skip and restart phase,
          // we will bring them back
          // showPhaseControls={
          //   findAssessmentType !== TestType.gait &&
          //   findAssessmentType !== TestType.five_x_sit_stand &&
          //   findAssessmentType !== TestType.tug
          // }
          showPhaseControls={false}
        />
      </IonModal>
      <IonModal
        className="exit-assessment-modal-wrap"
        backdropDismiss={false}
        isOpen={ExitAssessment}
        placeholder={undefined}
      >
        <ExitAssessmentTestModal
          setExitAssessment={setExitAssessment}
          onChildClick={handleChildClick}
        ></ExitAssessmentTestModal>
      </IonModal>
      <IonModal
        className="exit-assessment-modal-wrap"
        backdropDismiss={false}
        isOpen={notEnoughSpaceAssessment}
        placeholder={undefined}
      >
        <NotEnoughSpaceModal
          setExitAssessment={setNotEnoughSpaceAssessment}
          setAssesmentError={setAssesmentError}
        />
      </IonModal>
      <IonModal
        className="incomplete-test-modal-wrap"
        backdropDismiss={false}
        isOpen={IncompleteTest}
        placeholder={undefined}
      >
        <IncompleteTestModal
          setIncompleteTest={setIncompleteTest}
          onChildClick={handleChildClick}
        ></IncompleteTestModal>
      </IonModal>
      <IonModal
        className="space-verification-modal"
        backdropDismiss={false}
        isOpen={spaceVerification}
        placeholder={undefined}
      >
        <SpaceVerificationModal
          setspaceVerification={setspaceVerification}
        ></SpaceVerificationModal>
      </IonModal>
      <IonModal
        className="gait-analysis-completed"
        backdropDismiss={false}
        isOpen={gaitAnalysisCompleteModal}
        placeholder={undefined}
      >
        <GaitAnalysisCompletedModal
          setGaitAnalysisCompleted={setGaitAnalysisCompleted}
        ></GaitAnalysisCompletedModal>
      </IonModal>
      <IonModal
        className="when-ready-raise-hand-modal-wrap"
        backdropDismiss={false}
        isOpen={raiseArm}
        placeholder={undefined}
      >
        <WhenReadyRaiseHandModal
          setWhenReadyRaiseHand={setWhenReadyRaiseHand}
        ></WhenReadyRaiseHandModal>
      </IonModal>
      <IonModal
        className="when-ready-raise-hand-modal-wrap persistent"
        backdropDismiss={false}
        isOpen={raiseArmPersistent}
        placeholder={undefined}
      >
        <WhenReadyRaiseHandModal
          setWhenReadyRaiseHand={setWhenReadyRaiseHand}
          persistentMode={true}
        ></WhenReadyRaiseHandModal>
      </IonModal>
      <IonModal
        className="assesment-error-modal-wrap"
        backdropDismiss={false}
        isOpen={AssesmentError}
        placeholder={undefined}
      >
        <AssesmentErrorModal
          setAssesmentError={setAssesmentError}
        ></AssesmentErrorModal>
      </IonModal>
      <IonModal
        className={
          sessionStorage.getItem("selectedAssesment") === "55" ||
          sessionStorage.getItem("selectedAssesment") === "2" ||
          sessionStorage.getItem("selectedAssesment") === "1"
            ? "loader-popup-modal"
            : "participant-within-box-modal-wrap"
        }
        backdropDismiss={false}
        isOpen={ParticipantWithinBox}
        placeholder={undefined}
      >
        <ParticipantWithinBoxModal
          setParticipantWithinBox={setParticipantWithinBox}
        ></ParticipantWithinBoxModal>
      </IonModal>
      <IonModal
        className="exit-assessment-modal-wrap"
        backdropDismiss={false}
        isOpen={ShowFaceCameraPhase1Box}
        placeholder={undefined}
      >
        <AROMInitialModal
          phaseNo={sessionStorage.getItem("phaseNo") as string}
        ></AROMInitialModal>
      </IonModal>
      <IonModal
        className="exit-assessment-modal-wrap"
        backdropDismiss={false}
        isOpen={showFrModals}
        placeholder={undefined}
      >
        <FunctionalReachModals modalNum={frModalNum}></FunctionalReachModals>
      </IonModal>
      <IonModal
        className="exit-assessment-modal-wrap"
        backdropDismiss={false}
        isOpen={showmCTSIBModals}
        placeholder={undefined}
      >
        <CTSIBModals modalNum={mCTSIBModalNum}></CTSIBModals>
      </IonModal>
      <IonModal
        className="exit-assessment-modal-wrap"
        backdropDismiss={false}
        isOpen={ShowAromAssessmentGifModal}
        placeholder={undefined}
      >
        <AromAssessmentGifModal
          assessment={
            sessionStorage.getItem("selectedAssesment") === "55"
              ? (sessionStorage.getItem(
                  "aromAssessmentIndex",
                ) as AROM_ASSESSMENT)
              : (sessionStorage.getItem(
                  "functionalReachAssessmentIndex",
                ) as FUNCTIONAL_REACH_ASSESSMENT)
          }
        ></AromAssessmentGifModal>
      </IonModal>
      <IonModal
        className="exit-assessment-modal-wrap"
        backdropDismiss={false}
        isOpen={ShowAromAssessmentHandOrientationModal}
        placeholder={undefined}
      >
        <AromAssessmentHandOrientationModal
          assessment={
            sessionStorage.getItem("selectedAssesment") === "55"
              ? (sessionStorage.getItem(
                  "aromAssessmentIndex",
                ) as AROM_ASSESSMENT)
              : (sessionStorage.getItem(
                  "functionalReachAssessmentIndex",
                ) as FUNCTIONAL_REACH_ASSESSMENT)
          }
        ></AromAssessmentHandOrientationModal>
      </IonModal>
      <IonModal
        className="counter-error-modal"
        backdropDismiss={false}
        isOpen={ShowAromPhase1StartMessage}
        placeholder={undefined}
      >
        <AROMStartModal
          isOpen={ShowAromPhase1StartMessage}
          phaseNo={sessionStorage.getItem("phaseNo") as string}
          aromAssessmentIndex={
            sessionStorage.getItem("selectedAssesment") === "55"
              ? (sessionStorage.getItem(
                  "aromAssessmentIndex",
                ) as AROM_ASSESSMENT)
              : sessionStorage.getItem("selectedAssesment") === "1"
              ? (sessionStorage.getItem(
                  "mCTSIBAssessmentIndex"
                ) as mCTSIB_ASSESSMENT)
              : (sessionStorage.getItem(
                  "functionalReachAssessmentIndex",
                ) as FUNCTIONAL_REACH_ASSESSMENT)
          }
        ></AROMStartModal>
      </IonModal>
      <IonModal
        className="counter-error-modal"
        backdropDismiss={false}
        isOpen={ShowTugStartMessage}
        placeholder={undefined}
      >
        <TugStartModal isOpen={ShowTugStartMessage} />
      </IonModal>
      <IonModal
        className="counter-error-modal"
        backdropDismiss={false}
        isOpen={ShowTugChairBehindPatientMessage}
        placeholder={undefined}
      >
        <TugChairBehindPatientModal isOpen={ShowTugChairBehindPatientMessage} />
      </IonModal>

      <IonModal
        className="counter-error-modal"
        backdropDismiss={false}
        isOpen={ShowAromTherapistReadyMessage}
        placeholder={undefined}
      >
        <AROMTherapistReadyModal />
      </IonModal>
      <IonModal
        className="counter-error-modal persistent"
        backdropDismiss={false}
        isOpen={ShowAromTherapistReadyPersistent}
        placeholder={undefined}
      >
        <AROMTherapistReadyModal persistentMode={true} />
      </IonModal>
      <IonModal
        className="counter-error-modal"
        backdropDismiss={false}
        isOpen={ShowAromCompletionMessage}
        placeholder={undefined}
      >
        <AROMCompletionModal
          assessment={
            sessionStorage.getItem("selectedAssesment") === "55"
              ? (sessionStorage.getItem(
                  "aromAssessmentIndex",
                ) as AROM_ASSESSMENT)
              : sessionStorage.getItem("selectedAssesment") === "1"
              ? (sessionStorage.getItem(
                  "mCTSIBAssessmentIndex"
                ) as mCTSIB_ASSESSMENT)
              : (sessionStorage.getItem(
                  "functionalReachAssessmentIndex",
                ) as FUNCTIONAL_REACH_ASSESSMENT)
          }
        />
      </IonModal>
      <IonModal
        className="raise-hand-modal-wrap"
        backdropDismiss={false}
        isOpen={RaiseHand}
        placeholder={undefined}
      >
        <RaiseHandModal setRaiseHand={setRaiseHand}></RaiseHandModal>
      </IonModal>
      <IonModal
        className="raise-hand-modal-wrap persistent"
        backdropDismiss={false}
        isOpen={RaiseHandPersistent}
        placeholder={undefined}
      >
        <RaiseHandModal setRaiseHand={setRaiseHand} persistentMode={true}></RaiseHandModal>
      </IonModal>
      <IonModal
        className="person-detected-modal-wrap"
        backdropDismiss={false}
        isOpen={gaitCalibrationComplete}
        placeholder={undefined}
      >
        <GaitCalibrationComplete showTakeSeatText={findAssessmentType == TestType.five_x_sit_stand} />
      </IonModal>
      <IonModal
        className="counter-error-modal-transparent"
        backdropDismiss={false}
        isOpen={gaitDontWalk}
        placeholder={undefined}
      >
        <Dontwalkmodal progress={progress} />
      </IonModal>
      <IonModal
        className="person-detected-modal-wrap"
        backdropDismiss={false}
        isOpen={gaitPathwayBlocked}
        placeholder={undefined}
      >
        <GaitPathwayBlocked />
      </IonModal>
      <IonModal
        className="person-detected-modal-wrap"
        backdropDismiss={false}
        isOpen={personDetected}
        placeholder={undefined}
      >
        <PersonDetectedModal
          setPersonDetected={setPersonDetected}
        ></PersonDetectedModal>
      </IonModal>
      <IonModal
        className="are-you-there-modal-wrap"
        backdropDismiss={false}
        isOpen={AreYouThere}
        placeholder={undefined}
      >
        <AreYouThereModal setAreYouThere={setAreYouThere}></AreYouThereModal>
      </IonModal>
      <IonModal
        className="counter-error-modal"
        backdropDismiss={false}
        isOpen={GaitAssessmentCounter}
        placeholder={undefined}
      >
        <GaitAssessmentCounterModal
          setGaitAssessmentCounter={setGaitAssessmentCounter}
        ></GaitAssessmentCounterModal>
      </IonModal>
      <IonModal
        className="calibrating-loader-modal-wrap"
        backdropDismiss={false}
        isOpen={CalibratingLoader}
        placeholder={undefined}
      >
        <CalibratingLoaderModal
          setCalibratingLoader={handleExitClick}
        ></CalibratingLoaderModal>
      </IonModal>
      <IonPage placeholder={undefined}>
        <IonHeader className="ion-no-border" placeholder={undefined}>
          <div className="assessment-page-wrap">
            <div className="top-header-wrap">
              <div className="top-haeder-sec">
                <IonRow className="row" style={{ alignItems: "center" }} placeholder={undefined}>
                  <IonCol size="1" className="col-sec" style={{ display: "flex", alignItems: "center" }} placeholder={undefined}>
                    {sessionStorage.getItem("selectedAssesment") === "55" ||
                    sessionStorage.getItem("selectedAssesment") === "2" ||
                    sessionStorage.getItem("selectedAssesment") === "1" ||
                    sessionStorage.getItem("selectedAssesment") === "22" ||
                    sessionStorage.getItem("selectedAssesment") === "35" ||
                    sessionStorage.getItem("selectedAssesment") === "31" ? (
                      <div className="notification-msg-wrap">
                        <svg
                          onClick={() => {
                            ASSESSMENT_STATUSES.exit_assessment_modal = true;
                            setShowAromMenuModal(!showAromMenuModal);
                            // Stop voice listening when menu is opened (which may lead to exit)
                            console.log(
                              "🔊 Stopping voice listening due to menu open",
                            );
                            stopiOSVoiceListening();
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="34"
                          height="34"
                          viewBox="0 0 34 34"
                          fill="none"
                        >
                          <path
                            d="M0 4.55357C0 3.21027 1.08527 2.125 2.42857 2.125H31.5714C32.9147 2.125 34 3.21027 34 4.55357C34 5.89687 32.9147 6.98214 31.5714 6.98214H2.42857C1.08527 6.98214 0 5.89687 0 4.55357ZM0 16.6964C0 15.3531 1.08527 14.2679 2.42857 14.2679H31.5714C32.9147 14.2679 34 15.3531 34 16.6964C34 18.0397 32.9147 19.125 31.5714 19.125H2.42857C1.08527 19.125 0 18.0397 0 16.6964ZM34 28.8393C34 30.1826 32.9147 31.2679 31.5714 31.2679H2.42857C1.08527 31.2679 0 30.1826 0 28.8393C0 27.496 1.08527 26.4107 2.42857 26.4107H31.5714C32.9147 26.4107 34 27.496 34 28.8393Z"
                            fill="#802392"
                          />
                        </svg>
                      </div>
                    ) : (
                      <div
                        className="left-arrow"
                        onClick={() =>
                          (ASSESSMENT_STATUSES.debug_calibration =
                            !ASSESSMENT_STATUSES.debug_calibration)
                        }
                      >
                        {
                          <svg
                            width="7"
                            height="7"
                            viewBox="0 0 7 7"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="3.5" cy="3.5" r="3.5" fill="#002E3C" />
                          </svg>
                        }
                      </div>
                    )}
                  </IonCol>
                  <IonCol size="7" className="col-sec" placeholder={undefined}>
                    <div className="main-top-heading">
                      <h1
                        onClick={() =>
                          findAssessmentType == TestType.gait
                            ? setCalibrationErrorModal(true)
                            : ""
                        }
                      >
                        {sessionStorage.getItem("selectedAssesment") ===
                        "55" ? (
                          <>
                            {exitModalMessage === "default" &&
                            !headingUpdated ? (
                              <span style={{ paddingLeft: "245px" }}>
                                Assessment Setup
                              </span>
                            ) : (
                              <span style={{ paddingLeft: "185px", whiteSpace: "nowrap" }}>
                                Upper Body AROM Assessment
                              </span>
                            )}
                          </>
                        ) : sessionStorage.getItem("selectedAssesment") ===
                          "2" ? (
                          <>
                            {exitModalMessage === "default" &&
                            !headingUpdated ? (
                              <span style={{ paddingLeft: "245px" }}>
                                Assessment Setup
                              </span>
                            ) : (
                              <span style={{ paddingLeft: "150px" }}>
                                Functional Reach Assessment
                              </span>
                            )}
                          </>
                        ) : sessionStorage.getItem("selectedAssesment") ===
                          "1" ? (
                          <>
                            {exitModalMessage === "default" &&
                            !headingUpdated ? (
                              <span style={{ paddingLeft: "245px" }}>
                                Assessment Setup
                              </span>
                            ) : (
                              <span style={{ paddingLeft: "225px" }}>
                                mCTSIB Assessment
                              </span>
                            )}
                          </>
                        ) : (
                          <>
                            {exitModalMessage === "default"
                              ? <span style={{ paddingLeft: "245px" }}>
                                  Assessment Setup
                                </span>
                              : findAssessmentType == TestType.gait
                                ? "Gait Assessment"
                                : findAssessmentType ==
                                    TestType.five_x_sit_stand
                                  ? "5x STS Assessment"
                                  : findAssessmentType ==
                                      TestType.red_light_green_light &&
                                    "RLGL Assessment"}
                          </>
                        )}
                      </h1>
                    </div>
                  </IonCol>

                  <IonCol size="4" className="col-sec" placeholder={undefined}>
                    <div
                      className="right-cancel-btn"
                      onClick={() => {
                        if (!CalibrationError) {
                          // ASSESSMENT_STATUSES.exit_assessment_modal = true;
                          openModal();
                        }
                        findAssessmentType == TestType.five_x_sit_stand
                          ? setExitModalText("5xSTS ")
                          : setExitModalText("Gait");
                      }}
                    >
                      <span className="exit-name">Exit</span>
                      <svg
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.5 2L18.5 18"
                          stroke="#787B91"
                          strokeWidth="3.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M18.5 2L2.5 18"
                          stroke="#787B91"
                          strokeWidth="3.5"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                  </IonCol>
                </IonRow>
              </div>
            </div>
          </div>
        </IonHeader>
        <IonContent placeholder={undefined} className="slide-in-right">
          <IonGrid
            className="container assessment-page-wrap-container"
            placeholder={undefined}
          >
            <div className="assesment-count-wrap">
              {findAssessmentType === TestType.five_x_sit_stand && (
                <div id="div-sts-rep-count" className="count-text d-none"></div>
              )}
              {currentAssessment.testJson &&
                findAssessmentType === TestType.five_x_sit_stand && (
                  <div className="assesment-tick-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="166"
                      height="166"
                      viewBox="0 0 166 166"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M82.999 0.706055C37.5493 0.706055 0.705078 37.5503 0.705078 83C0.705078 128.45 37.5493 165.294 82.999 165.294C128.449 165.294 165.293 128.45 165.293 83C165.293 37.5503 128.449 0.706055 82.999 0.706055Z"
                        fill="#43BA73"
                      />
                      <path
                        d="M107.688 66.541L74.7703 99.4586L58.3115 82.9998"
                        stroke="white"
                        strokeWidth="20"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                )}
            </div>
            <div className="assessment-page-wrap">
              <div id="stats" style={{ display: "none" }}></div>

              <div className="assessment-video-wrap">
                {showMicrophone && (
                  <div
                    style={{
                      position: "fixed",
                      bottom: "20px",
                      left: "20px",
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      background: "rgba(0, 0, 0, 0.7)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      zIndex: 1000,
                    }}
                    onClick={() => {
                      console.log("Microphone clicked");
                    }}
                  >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="white"
                  >
                    <path d="M12 14C13.66 14 15 12.66 15 11V5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5V11C9 12.66 10.34 14 12 14ZM10.8 4.9C10.8 4.24 11.34 3.7 12 3.7C12.66 3.7 13.2 4.24 13.2 4.9L13.19 11.1C13.19 11.76 12.66 12.3 12 12.3C11.34 12.3 10.8 11.76 10.8 11.1V4.9ZM17 11C17 13.76 14.76 16 12 16C9.24 16 7 13.76 7 11H5C5 14.53 7.61 17.43 11 17.92V21H13V17.92C16.39 17.43 19 14.53 19 11H17Z"/>
                  </svg>
                  </div>
                )}
                <div id="main">
                  <div className="canvas-wrapper">
                    <canvas id="output"></canvas>
                    <canvas
                      id="insetoutput"
                      data-val="true"
                      data-start="true"
                      style={{
                        cursor: "pointer",
                        width: "150px",
                        height: "200px",
                      }}
                      onClick={() => setInsetDefaultView()}
                    ></canvas>
                    {(sessionStorage.getItem("selectedAssesment") === "55" ||
                      sessionStorage.getItem("selectedAssesment") === "2") && (
                      <div
                        style={{
                          position: "absolute",
                          right: "0",
                          width: "120px",
                          height: "120px",
                          borderRadius: "0px 0px 0px 100%",
                          background: "#000000B2",
                          display: "flex",
                          alignItems: "flex-end",
                          justifyContent: "flex-end",
                          paddingRight: "25px",
                          paddingBottom: "25px",
                        }}
                      >
                        <div
                          style={{
                            position: "relative",
                            top: "-7px",
                          }}
                          onClick={() => {
                            if (
                              sessionStorage.getItem("selectedAssesment") ===
                              "55"
                            )
                              AromMenuOptions.restartSubAssessment = true;
                            else AromMenuOptions.restartPhase = true;
                            console.log("restart assessment");
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="42"
                            height="48"
                            viewBox="0 0 49 48"
                            fill="none"
                          >
                            <path
                              d="M24.9453 48C31.3105 48 37.415 45.4714 41.9159 40.9706C46.4167 36.4697 48.9453 30.3652 48.9453 24C48.9453 17.6348 46.4167 11.5303 41.9159 7.02944C37.415 2.52856 31.3105 0 24.9453 0C18.5801 0 12.4756 2.52856 7.97475 7.02944C3.47388 11.5303 0.945313 17.6348 0.945312 24C0.945313 30.3652 3.47388 36.4697 7.97475 40.9706C12.4756 45.4714 18.5801 48 24.9453 48ZM16.8641 15.4969C17.6047 13.4062 19.5922 12 21.8141 12H27.2797C30.5516 12 33.1953 14.6531 33.1953 17.9156C33.1953 20.0344 32.0609 21.9937 30.2234 23.0531L27.1953 24.7875C27.1766 26.0062 26.1734 27 24.9453 27C23.6984 27 22.6953 25.9969 22.6953 24.75V23.4844C22.6953 22.6781 23.1266 21.9375 23.8297 21.5344L27.9828 19.1531C28.4234 18.9 28.6953 18.4312 28.6953 17.925C28.6953 17.1375 28.0578 16.5094 27.2797 16.5094H21.8141C21.4953 16.5094 21.2141 16.7062 21.1109 17.0062L21.0734 17.1188C20.6609 18.2906 19.3672 18.9 18.2047 18.4875C17.0422 18.075 16.4234 16.7812 16.8359 15.6188L16.8734 15.5062L16.8641 15.4969ZM21.9453 33C21.9453 32.2043 22.2614 31.4413 22.824 30.8787C23.3866 30.3161 24.1497 30 24.9453 30C25.741 30 26.504 30.3161 27.0666 30.8787C27.6292 31.4413 27.9453 32.2043 27.9453 33C27.9453 33.7957 27.6292 34.5587 27.0666 35.1213C26.504 35.6839 25.741 36 24.9453 36C24.1497 36 23.3866 35.6839 22.824 35.1213C22.2614 34.5587 21.9453 33.7957 21.9453 33Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                    )}
                    <AromTopRightGif path={AdductionAbductionGif} />
                    <AROMRealTime />
                    {sessionStorage.getItem("selectedAssesment") === "50" && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "24px",
                          padding: "40px 5px 5px 25px",
                        }}
                      >
                        <div
                          className="arom-top-left-icon"
                          id="arom-fast-backward"
                          style={{ display: "none" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="36"
                            height="32"
                            viewBox="0 0 36 32"
                            fill="none"
                          >
                            <path
                              d="M33.1367 5.55722C33.6873 5.25131 34.3587 5.25962 34.9016 5.57906C35.4445 5.8985 35.7778 6.48137 35.7778 7.11127V24.8891C35.7778 25.519 35.4445 26.1018 34.9016 26.4213C34.3587 26.7407 33.6873 26.749 33.1367 26.4431L19.7778 19.0215L19.7778 24.8891C19.7778 25.519 19.4445 26.1018 18.9016 26.4213C18.3587 26.7407 17.6873 26.749 17.1367 26.4431L1.13668 17.5542C0.572304 17.2407 0.222275 16.6458 0.222275 16.0002C0.222275 15.3545 0.572304 14.7597 1.13668 14.4461L17.1367 5.55722C17.6873 5.25131 18.3587 5.25962 18.9016 5.57906C19.4445 5.8985 19.7778 6.48137 19.7778 7.11127V12.9788L33.1367 5.55722Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div
                          className="arom-top-left-icon"
                          id="arom-retry"
                          style={{ display: "none" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="34"
                            viewBox="0 0 30 34"
                            fill="none"
                          >
                            <path
                              d="M25.9667 1C26.832 1 27.5334 1.71634 27.5334 2.6V10.6C27.5334 11.4837 26.832 12.2 25.9667 12.2H18.1332C17.2679 12.2 16.5665 11.4837 16.5665 10.6C16.5665 9.71634 17.2679 9 18.1332 9H22.675C21.9224 8.24691 21.0638 7.60485 20.1231 7.09726C18.3089 6.11837 16.2623 5.67885 14.2157 5.82867C12.1692 5.97849 10.2048 6.71163 8.5459 7.94476C6.88701 9.1779 5.60012 10.8616 4.8315 12.8044C4.50736 13.6237 3.59424 14.0196 2.79199 13.6885C1.98973 13.3575 1.60213 12.425 1.92626 11.6057C2.91449 9.10773 4.56906 6.94301 6.70193 5.35755C8.83479 3.77209 11.3604 2.82948 13.9917 2.63686C16.623 2.44424 19.2544 3.00933 21.5869 4.26791C22.6056 4.81758 23.5494 5.4899 24.4 6.26686V2.6C24.4 1.71634 25.1014 1 25.9667 1Z"
                              fill="white"
                            />
                            <path
                              d="M28.0736 22.3943C28.3978 21.575 28.0102 20.6425 27.2079 20.3115C26.4057 19.9804 25.4925 20.3763 25.1684 21.1956C24.3998 23.1384 23.1129 24.8221 21.454 26.0552C19.7951 27.2884 17.8307 28.0215 15.7842 28.1713C13.7376 28.3211 11.691 27.8816 9.87681 26.9027C8.93611 26.3951 8.07749 25.7531 7.32487 25H11.8664C12.7317 25 13.4331 24.2837 13.4331 23.4C13.4331 22.5163 12.7317 21.8 11.8664 21.8H4.03291C3.16765 21.8 2.46622 22.5163 2.46622 23.4V31.4C2.46622 32.2837 3.16765 33 4.03291 33C4.89818 33 5.59961 32.2837 5.59961 31.4V27.7329C6.45028 28.5099 7.39421 29.1824 8.41301 29.7321C10.7455 30.9907 13.3769 31.5558 16.0082 31.3631C18.6395 31.1705 21.1651 30.2279 23.298 28.6424C25.4308 27.057 27.0854 24.8923 28.0736 22.3943Z"
                              fill="white"
                            />
                            <path
                              d="M25.9667 1C26.832 1 27.5334 1.71634 27.5334 2.6V10.6C27.5334 11.4837 26.832 12.2 25.9667 12.2H18.1332C17.2679 12.2 16.5665 11.4837 16.5665 10.6C16.5665 9.71634 17.2679 9 18.1332 9H22.675C21.9224 8.24691 21.0638 7.60485 20.1231 7.09726C18.3089 6.11837 16.2623 5.67885 14.2157 5.82867C12.1692 5.97849 10.2048 6.71163 8.5459 7.94476C6.88701 9.1779 5.60012 10.8616 4.8315 12.8044C4.50736 13.6237 3.59424 14.0196 2.79199 13.6885C1.98973 13.3575 1.60213 12.425 1.92626 11.6057C2.91449 9.10773 4.56906 6.94301 6.70193 5.35755C8.83479 3.77209 11.3604 2.82948 13.9917 2.63686C16.623 2.44424 19.2544 3.00933 21.5869 4.26791C22.6056 4.81758 23.5494 5.4899 24.4 6.26686V2.6C24.4 1.71634 25.1014 1 25.9667 1Z"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M28.0736 22.3943C28.3978 21.575 28.0102 20.6425 27.2079 20.3115C26.4057 19.9804 25.4925 20.3763 25.1684 21.1956C24.3998 23.1384 23.1129 24.8221 21.454 26.0552C19.7951 27.2884 17.8307 28.0215 15.7842 28.1713C13.7376 28.3211 11.691 27.8816 9.87681 26.9027C8.93611 26.3951 8.07749 25.7531 7.32487 25H11.8664C12.7317 25 13.4331 24.2837 13.4331 23.4C13.4331 22.5163 12.7317 21.8 11.8664 21.8H4.03291C3.16765 21.8 2.46622 22.5163 2.46622 23.4V31.4C2.46622 32.2837 3.16765 33 4.03291 33C4.89818 33 5.59961 32.2837 5.59961 31.4V27.7329C6.45028 28.5099 7.39421 29.1824 8.41301 29.7321C10.7455 30.9907 13.3769 31.5558 16.0082 31.3631C18.6395 31.1705 21.1651 30.2279 23.298 28.6424C25.4308 27.057 27.0854 24.8923 28.0736 22.3943Z"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div
                          className="arom-top-left-icon"
                          id="arom-fast-forward"
                          style={{ display: "none" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="36"
                            height="32"
                            viewBox="0 0 36 32"
                            fill="none"
                          >
                            <path
                              d="M2.86331 5.55722C2.31268 5.25131 1.64128 5.25962 1.09839 5.57906C0.555491 5.8985 0.222168 6.48137 0.222168 7.11127L0.222168 24.8891C0.222168 25.519 0.555491 26.1018 1.09839 26.4213C1.64128 26.7407 2.31268 26.749 2.86331 26.4431L16.2222 19.0215L16.2222 24.8891C16.2222 25.519 16.5555 26.1018 17.0984 26.4213C17.6413 26.7407 18.3127 26.749 18.8633 26.4431L34.8633 17.5542C35.4277 17.2407 35.7777 16.6458 35.7777 16.0002C35.7777 15.3545 35.4277 14.7597 34.8633 14.4461L18.8633 5.55722C18.3127 5.25131 17.6413 5.25962 17.0984 5.57906C16.5555 5.8985 16.2222 6.48137 16.2222 7.11127V12.9788L2.86331 5.55722Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                    )}
                    <video
                      id="video"
                      playsInline
                      autoPlay={true}
                      muted
                      style={{
                        transform: "scaleX(-1)",
                        visibility: "hidden",
                        width: "auto",
                        height: "auto",
                      }}
                    >
                      {/* <source src="videos/IMG_5547.MOV" type="video/mp4" /> */}

                      {findAssessmentType == TestType.gait ? (
                        <source
                          src="videos/1080p/case_1.mp4"
                          type="video/mp4"
                        />
                      ) : (
                        <source src="videos/sitstand5.mp4" type="video/mp4" />
                      )}
                    </video>
                  </div>
                  <div id="scatter-gl-container"></div>
                </div>
              </div>
            </div>
            <audio
              id="audio-paper-placement"
              src="audios/gait/paper_placement.mp3"
              preload="auto"
            >
              <source />
            </audio>
            <canvas id="chart-bev-y"></canvas>
            <canvas id="chart-slope"></canvas>
            <div
              id="angle_values"
              style={{
                display: "none",
                textAlign: "center",
                position: "absolute",
                zIndex: 100,
                width: "100%",
                height: "75px",
                color: "black",
                bottom: "75px",
                fontSize: "60px",
                fontFamily: "bold",
              }}
            ></div>
            {startCounter && <AromCountdownTimer />}
          </IonGrid>
          {/* SwayVisualizer: Only show for current sub-assessment and not in post_assessment_modal */}
          {swayX.length > 0 && swayY.length > 0 && (
            <SwayVisualizer swayX={swayX} swayY={swayY} />
          )}
        </IonContent>
      </IonPage>
    </>
  );
};

export default AssessmentPage;
